// // import React, {
// //   useState,
// //   useEffect,
// //   useMemo,
// //   useRef,
// //   useCallback,
// // } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Paper,
// //   Chip,
// //   Button,
// //   Divider,
// //   CircularProgress,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   IconButton,
// //   TextField,
// //   Snackbar,
// //   Alert,
// // } from "@mui/material";
// // import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// // import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// // import AccessTimeIcon from "@mui/icons-material/AccessTime";
// // import RestaurantIcon from "@mui/icons-material/Restaurant";
// // import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// // import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
// // import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// // import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// // import EditIcon from "@mui/icons-material/Edit";
// // import CancelIcon from "@mui/icons-material/Cancel";
// // import RefreshIcon from "@mui/icons-material/Refresh";
// // import StarIcon from "@mui/icons-material/Star";
// // import { useMyOrders } from "../../../hooks/useMyOrders";
// // import { useDispatch, useSelector } from "react-redux";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   addItem,
// //   clearCart,
// //   setRestaurant,
// //   selectCartRestaurant,
// //   setUpdateOrderId,
// // } from "../../../redux/slices/cartSlice";
// // import { updateCartCalculation } from "../../../redux/slices/publicSlice";
// // import { useSocket } from "../../../context/SocketContext";
// // import { setupPushNotifications } from "../../../utils/pushNotifications";
// // import jsPDF from "jspdf";
// // import autoTable from "jspdf-autotable";
// // import DownloadIcon from "@mui/icons-material/Download";

// // const PAGE_SIZE = 8; // ⭐ 8 orders per page

// // // ========== OrderType Components ==========
// // const OrderTypeIcon = ({ type }) => {
// //   const icons = {
// //     DINE_IN: <RestaurantIcon sx={{ fontSize: 16, color: "#2e7d32", ml: 1 }} />,
// //     DELIVERY: (
// //       <LocalShippingIcon sx={{ fontSize: 16, color: "#1976d2", ml: 1 }} />
// //     ),
// //     TAKEAWAY: (
// //       <TakeoutDiningIcon sx={{ fontSize: 16, color: "#e65100", ml: 1 }} />
// //     ),
// //   };
// //   return icons[type] || icons.DINE_IN;
// // };

// // const OrderTypeLabel = ({ type }) => {
// //   const labels = {
// //     DINE_IN: "Dine In",
// //     DELIVERY: "Delivery",
// //     TAKEAWAY: "Takeaway",
// //   };
// //   const colors = {
// //     DINE_IN: "#2e7d32",
// //     DELIVERY: "#1976d2",
// //     TAKEAWAY: "#e65100",
// //   };
// //   return (
// //     <Chip
// //       label={labels[type] || type}
// //       size="small"
// //       icon={<OrderTypeIcon type={type} />}
// //       sx={{
// //         height: 22,
// //         fontSize: "0.65rem",
// //         fontWeight: 600,
// //         bgcolor: `${colors[type] || "#2e7d32"}15`,
// //         color: colors[type] || "#2e7d32",
// //         border: `1px solid ${colors[type] || "#2e7d32"}40`,
// //         "& .MuiChip-icon": { fontSize: 14 },
// //       }}
// //     />
// //   );
// // };

// // // Status Chip
// // // const StatusChip = ({ status }) => {
// // //   const colors = {
// // //     PENDING: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
// // //     ACCEPTED: { bg: "#e3f2fd", color: "#1565c0", border: "#64b5f6" },
// // //     PREPARING: { bg: "#f3e5f5", color: "#6a1b9a", border: "#ba68c8" },
// // //     COMPLETED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
// // //     DELIVERED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
// // //     CANCELLED: { bg: "#ffebee", color: "#c62828", border: "#ef9a9a" },
// // //   };
// // //   const c = colors[status] || colors.PENDING;
// // //   return (
// // //     <Chip
// // //       label={status}
// // //       size="small"
// // //       sx={{
// // //         height: 20,
// // //         fontSize: "0.62rem",
// // //         fontWeight: 700,
// // //         bgcolor: c.bg,
// // //         color: c.color,
// // //         border: `1px solid ${c.border}`,
// // //       }}
// // //     />
// // //   );
// // // };

// // // Status Chip (Line 100 in src/pages/public/tabs/OrdersPage.js)
// // const StatusChip = ({ status }) => {
// //   const colors = {
// //     PENDING: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
// //     ACCEPTED: { bg: "#e3f2fd", color: "#1565c0", border: "#64b5f6" },
// //     PREPARING: { bg: "#f3e5f5", color: "#6a1b9a", border: "#ba68c8" },
// //     OUT_FOR_DELIVERY: { bg: "#fff8e1", color: "#f57f17", border: "#ffd54f" }, // 👈 ADD THIS LINE
// //     COMPLETED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
// //     DELIVERED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
// //     CANCELLED: { bg: "#ffebee", color: "#c62828", border: "#ef9a9a" },
// //   };
// //   const c = colors[status] || colors.PENDING;
// //   return (
// //     <Chip
// //       label={status}
// //       size="small"
// //       sx={{
// //         height: 20,
// //         fontSize: "0.62rem",
// //         fontWeight: 700,
// //         bgcolor: c.bg,
// //         color: c.color,
// //         border: `1px solid ${c.border}`,
// //       }}
// //     />
// //   );
// // };

// // // ========== OrderItems ==========
// // const OrderItems = ({ items, freeItems }) => {
// //   const [expanded, setExpanded] = useState(false);
// //   const initialDisplay = 3;
// //   const hasMoreItems = items?.length > initialDisplay;
// //   const displayItems = expanded ? items : items?.slice(0, initialDisplay) || [];

// //   return (
// //     <Box>
// //       <Box sx={{ mb: 1.2 }}>
// //         {items && items.length > 0 ? (
// //           <>
// //             {displayItems.map((item, i) => {
// //               const isFree =
// //                 item.isFree ||
// //                 item.price === 0 ||
// //                 item.itemName?.includes("FREE");
// //               return (
// //                 <Box key={i}>
// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       alignItems: "flex-start",
// //                       mb: 0.4,
// //                       opacity: isFree ? 0.8 : 1,
// //                     }}
// //                   >
// //                     <Box sx={{ flex: 1 }}>
// //                       <Typography
// //                         variant="caption"
// //                         sx={{
// //                           color: isFree ? "#888" : "#555",
// //                           fontSize: "0.78rem",
// //                           textDecoration: isFree ? "line-through" : "none",
// //                         }}
// //                       >
// //                         {item.itemName} × {item.quantity}
// //                         {isFree && (
// //                           <Chip
// //                             label="FREE"
// //                             size="small"
// //                             sx={{
// //                               ml: 1,
// //                               height: 16,
// //                               fontSize: "0.5rem",
// //                               bgcolor: "#e8f5e9",
// //                               color: "#2e7d32",
// //                               fontWeight: 700,
// //                             }}
// //                           />
// //                         )}
// //                       </Typography>
// //                       {item.appliedOffer && !isFree && (
// //                         <Typography
// //                           variant="caption"
// //                           sx={{
// //                             color: "#2e7d32",
// //                             fontSize: "0.65rem",
// //                             display: "block",
// //                             mt: 0.2,
// //                           }}
// //                         >
// //                           🏷️️ {item.appliedOffer.offerCode} - Saved ₹
// //                           {(
// //                             (item.originalPrice - item.price) *
// //                             item.quantity
// //                           ).toFixed(0)}
// //                         </Typography>
// //                       )}
// //                       {(item.selectedSize ||
// //                         item.selectedVariant ||
// //                         item.selectedAddons?.length > 0) && (
// //                         <Typography
// //                           variant="caption"
// //                           sx={{
// //                             color: "#999",
// //                             fontSize: "0.6rem",
// //                             display: "block",
// //                             mt: 0.1,
// //                           }}
// //                         >
// //                           {[
// //                             item.selectedSize?.name &&
// //                               `Size: ${item.selectedSize.name}`,
// //                             item.selectedVariant?.name &&
// //                               `Variant: ${item.selectedVariant.name}`,
// //                             item.selectedAddons?.length > 0 &&
// //                               `Addons: ${item.selectedAddons
// //                                 .map((a) => a.name)
// //                                 .join(", ")}`,
// //                           ]
// //                             .filter(Boolean)
// //                             .join(" · ")}
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                     <Box sx={{ textAlign: "right" }}>
// //                       {isFree ? (
// //                         <Chip
// //                           label="FREE"
// //                           size="small"
// //                           sx={{
// //                             height: 16,
// //                             fontSize: "0.55rem",
// //                             bgcolor: "#e8f5e9",
// //                             color: "#2e7d32",
// //                             fontWeight: 700,
// //                           }}
// //                         />
// //                       ) : item.appliedOffer ? (
// //                         <>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{
// //                               color: "#999",
// //                               textDecoration: "line-through",
// //                               fontSize: "0.7rem",
// //                               display: "block",
// //                             }}
// //                           >
// //                             ₹{(item.originalPrice * item.quantity).toFixed(0)}
// //                           </Typography>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{
// //                               color: "#2e7d32",
// //                               fontWeight: 600,
// //                               fontSize: "0.78rem",
// //                             }}
// //                           >
// //                             ₹{(item.price * item.quantity).toFixed(0)}
// //                           </Typography>
// //                         </>
// //                       ) : (
// //                         <Typography
// //                           variant="caption"
// //                           sx={{
// //                             color: "#333",
// //                             fontWeight: 600,
// //                             fontSize: "0.78rem",
// //                           }}
// //                         >
// //                           ₹{(item.price * item.quantity).toFixed(0)}
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                   </Box>
// //                 </Box>
// //               );
// //             })}

// //             {hasMoreItems && (
// //               <Button
// //                 size="small"
// //                 onClick={() => setExpanded(!expanded)}
// //                 endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
// //                 sx={{
// //                   mt: 0.5,
// //                   fontSize: "0.7rem",
// //                   fontWeight: 600,
// //                   color: "#2e7d32",
// //                   textTransform: "none",
// //                   "&:hover": { bgcolor: "#e8f5e9" },
// //                 }}
// //               >
// //                 {expanded
// //                   ? `Show Less (${items.length} items)`
// //                   : `Show ${items.length - initialDisplay} more item${
// //                       items.length - initialDisplay !== 1 ? "s" : ""
// //                     }`}
// //               </Button>
// //             )}
// //           </>
// //         ) : (
// //           <Typography
// //             variant="caption"
// //             sx={{ color: "#999", fontStyle: "italic" }}
// //           >
// //             No items to display
// //           </Typography>
// //         )}
// //       </Box>

// //       {freeItems && freeItems.length > 0 && (
// //         <Box
// //           sx={{
// //             mb: 1,
// //             bgcolor: "#e8f5e9",
// //             p: 1,
// //             borderRadius: 1,
// //             border: "1px solid #c8e6c9",
// //           }}
// //         >
// //           <Typography
// //             variant="caption"
// //             sx={{
// //               color: "#2e7d32",
// //               fontWeight: 700,
// //               fontSize: "0.75rem",
// //               display: "block",
// //               mb: 0.5,
// //             }}
// //           >
// //             🎁 Free Items from Offers
// //           </Typography>
// //           {freeItems.map((item, i) => (
// //             <Box
// //               key={i}
// //               sx={{
// //                 display: "flex",
// //                 justifyContent: "space-between",
// //                 alignItems: "center",
// //                 mb: 0.3,
// //               }}
// //             >
// //               <Typography
// //                 variant="caption"
// //                 sx={{ color: "#555", fontSize: "0.78rem" }}
// //               >
// //                 {item.itemName} × {item.quantity}
// //               </Typography>
// //               <Chip
// //                 label={`FREE (₹${(item.price * item.quantity).toFixed(
// //                   0,
// //                 )} saved)`}
// //                 size="small"
// //                 sx={{
// //                   height: 18,
// //                   fontSize: "0.55rem",
// //                   bgcolor: "#2e7d32",
// //                   color: "white",
// //                 }}
// //               />
// //             </Box>
// //           ))}
// //         </Box>
// //       )}
// //     </Box>
// //   );
// // };

// // // ========== MAIN OrdersPage ==========
// // const OrdersPage = ({ restaurantId, restaurantInfo }) => {
// //   const {
// //     orders = [],
// //     loading,
// //     loadingMore, // ⭐ pagination loading
// //     hasMore, // ⭐ end-of-list flag
// //     currentPage, // ⭐
// //     error,
// //     getMyOrders,
// //     updateMyOrder,
// //     cancelMyOrder,
// //     clearError,
// //   } = useMyOrders();

// //   const dispatch = useDispatch();
// //   const navigate = useNavigate();
// //   const { socket } = useSocket();
// //   const cartRestaurant = useSelector(selectCartRestaurant);

// //   const [snack, setSnack] = useState({ open: false, msg: "", type: "success" });
// //   const [cancelDialog, setCancelDialog] = useState({
// //     open: false,
// //     order: null,
// //   });
// //   const [cancelReason, setCancelReason] = useState("");
// //   const [reviewModal, setReviewModal] = useState({
// //     open: false,
// //     order: null,
// //   });

// //   // ⭐ Infinite scroll sentinel ref
// //   const loadMoreRef = useRef(null);

// //   // ⭐ Refresh helper that preserves already-loaded pages
// //   const refreshLoadedOrders = useCallback(() => {
// //     const safePage = currentPage || 1;
// //     const limit = Math.max(PAGE_SIZE, safePage * PAGE_SIZE);
// //     getMyOrders({ page: 1, limit, append: false });
// //   }, [getMyOrders, currentPage]);

// //   // Mount par / restaurant change par page 1 load karein
// //   useEffect(() => {
// //     getMyOrders({ page: 1, limit: PAGE_SIZE, append: false });
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [restaurantId]);

// //   useEffect(() => {
// //     if (restaurantId) {
// //       setupPushNotifications(restaurantId);
// //     }
// //   }, [restaurantId]);

// //   // Real-time socket status updates (refresh currently-loaded pages)
// //   useEffect(() => {
// //     if (!socket) return;
// //     const handleUpdate = () => refreshLoadedOrders();
// //     socket.on("order-status-updated", handleUpdate);
// //     socket.on("new-order", handleUpdate);
// //     return () => {
// //       socket.off("order-status-updated", handleUpdate);
// //       socket.off("new-order", handleUpdate);
// //     };
// //   }, [socket, refreshLoadedOrders]);

// //   // Error snackbar
// //   useEffect(() => {
// //     if (error) {
// //       setSnack({ open: true, msg: error, type: "error" });
// //       clearError();
// //     }
// //   }, [error, clearError]);

// //   // FIX: Slug aur ObjectId dono se match karein
// //   const filteredOrders = useMemo(() => {
// //     if (!orders || orders.length === 0) return [];

// //     const currentSlug =
// //       restaurantInfo?.slug ||
// //       (restaurantId?.length !== 24 ? restaurantId : null);
// //     const currentObjectId =
// //       restaurantInfo?._id?.toString() ||
// //       (restaurantId?.length === 24 ? restaurantId : null);

// //     return orders.filter((o) => {
// //       const rest = o.restaurant || {};
// //       const restId = (rest._id || rest.id || rest).toString();
// //       const restSlug = rest.slug;

// //       if (currentSlug && restSlug && restSlug === currentSlug) return true;
// //       if (currentSlug && restId === currentSlug) return true;
// //       if (currentObjectId && restId === currentObjectId) return true;
// //       if (restId === restaurantId || restSlug === restaurantId) return true;

// //       return false;
// //     });
// //   }, [orders, restaurantId, restaurantInfo]);

// //   // ⭐ Infinite scroll — IntersectionObserver on sentinel
// //   useEffect(() => {
// //     if (!hasMore || loading || loadingMore) return;
// //     const node = loadMoreRef.current;
// //     if (!node) return;

// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         if (entries[0]?.isIntersecting) {
// //           getMyOrders({
// //             page: (currentPage || 1) + 1,
// //             limit: PAGE_SIZE,
// //             append: true,
// //           });
// //         }
// //       },
// //       { rootMargin: "200px 0px" }, // 200px before bottom
// //     );

// //     observer.observe(node);
// //     return () => observer.disconnect();
// //   }, [hasMore, loading, loadingMore, currentPage, getMyOrders]);

// //   // Cancel handlers
// //   const handleCancelClick = (order) => {
// //     setCancelDialog({ open: true, order });
// //     setCancelReason("");
// //   };

// //   const handleCancelConfirm = async () => {
// //     try {
// //       await cancelMyOrder(
// //         cancelDialog.order._id || cancelDialog.order.id,
// //         cancelReason,
// //       );
// //       setSnack({
// //         open: true,
// //         msg: "Order cancelled successfully",
// //         type: "success",
// //       });
// //       refreshLoadedOrders();
// //     } catch (err) {
// //       setSnack({
// //         open: true,
// //         msg: err?.message || "Cancel failed",
// //         type: "error",
// //       });
// //     } finally {
// //       setCancelDialog({ open: false, order: null });
// //       setCancelReason("");
// //     }
// //   };

// //   // ⭐ Auto-Trigger Review Modal for COMPLETED / DELIVERED orders
// //   const checkAndTriggerReview = (ordersList) => {
// //     if (!ordersList || ordersList.length === 0) return;

// //     const unratedCompletedOrder = ordersList.find((o) => {
// //       const isDone = o.status === "COMPLETED" || o.status === "DELIVERED";
// //       const orderId = o._id || o.id;
// //       const alreadyRated = localStorage.getItem(`rated_order_${orderId}`);
// //       return isDone && !alreadyRated;
// //     });

// //     if (unratedCompletedOrder) {
// //       setReviewModal({
// //         open: true,
// //         order: unratedCompletedOrder,
// //       });
// //     }
// //   };

// //   // Check on orders fetch
// //   useEffect(() => {
// //     if (filteredOrders.length > 0) {
// //       checkAndTriggerReview(filteredOrders);
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [filteredOrders]);

// //   // Real-time socket review trigger
// //   useEffect(() => {
// //     if (!socket) return;
// //     const handleUpdate = (data) => {
// //       refreshLoadedOrders();
// //       if (data?.order) {
// //         const orderStatus = data.order.status;
// //         const orderId = data.order._id || data.order.id;
// //         const alreadyRated = localStorage.getItem(`rated_order_${orderId}`);
// //         if (
// //           (orderStatus === "COMPLETED" || orderStatus === "DELIVERED") &&
// //           !alreadyRated
// //         ) {
// //           setReviewModal({
// //             open: true,
// //             order: data.order,
// //           });
// //         }
// //       }
// //     };

// //     socket.on("order-status-updated", handleUpdate);
// //     socket.on("new-order", handleUpdate);
// //     return () => {
// //       socket.off("order-status-updated", handleUpdate);
// //       socket.off("new-order", handleUpdate);
// //     };
// //   }, [socket, refreshLoadedOrders]);

// //   // UPDATE ORDER (Cart Load & Sync with exact Identifier)
// //   const handleUpdateClick = (order) => {
// //     try {
// //       const orderId = order._id || order.id;
// //       const shortId = orderId?.toString().slice(-8).toUpperCase();

// //       // const confirmed = window.confirm(
// //       //   `Order #${shortId} ke items cart me load ho jayenge.\n\n` +
// //       //     `Aap cart me items add/remove kar sakte ho aur phir "Update Order" click karke update kar sakte ho.\n\n` +
// //       //     `Continue?`
// //       // );

// //       const confirmed = window.confirm(
// //         `Items from Order #${shortId} will be loaded into your cart.\n\n` +
// //           `You can add or remove items in the cart and click "Update Order" to apply the changes.\n\n` +
// //           `Do you want to continue?`,
// //       );

// //       if (!confirmed) return;

// //       dispatch(clearCart());

// //       const targetRestaurantId = restaurantInfo?._id || restaurantId;
// //       dispatch(setRestaurant(targetRestaurantId));
// //       dispatch(setUpdateOrderId(orderId));

// //       if (order.appliedOffers && order.appliedOffers.length > 0) {
// //         dispatch(
// //           updateCartCalculation({
// //             appliedOffers: order.appliedOffers,
// //             promoDiscount:
// //               order.orderSummary?.totalDiscount || order.totalDiscount || 0,
// //             totalDiscount:
// //               order.orderSummary?.totalDiscount || order.totalDiscount || 0,
// //             finalTotal: order.orderSummary?.totalAmount || order.total || 0,
// //             subtotal: order.orderSummary?.subtotal || order.subtotal || 0,
// //             freeItems: order.freeItems || [],
// //           }),
// //         );
// //       }

// //       // Pre-select OrderType for CartDrawer
// //       if (order.orderType) {
// //         localStorage.setItem(
// //           `selected_order_type_${targetRestaurantId}`,
// //           order.orderType,
// //         );
// //       }

// //       let loadedCount = 0;
// //       (order.items || []).forEach((item) => {
// //         const isFree =
// //           item.isFree || item.price === 0 || item.itemName?.includes("FREE");
// //         if (isFree) return;

// //         const itemId =
// //           typeof item.itemId === "object"
// //             ? item.itemId?._id
// //             : item.itemId || item._id;
// //         if (!itemId) return;

// //         const cartItem = {
// //           _id: itemId,
// //           itemName: item.itemName?.replace(" (FREE)", "") || "Item",
// //           price: item.originalPrice || item.price || 0,
// //           originalPrice: item.originalPrice || item.price || 0,
// //           discountedPrice: item.price || 0,
// //           basePrice: item.originalPrice || item.price || 0,
// //           qty: 1,
// //           quantity: 1,
// //           isVeg: item.isVeg ?? true,
// //           image:
// //             item.image ||
// //             (typeof item.itemId === "object" ? item.itemId?.image : "") ||
// //             "",
// //           selectedSize: item.selectedSize || null,
// //           selectedVariant: item.selectedVariant || null,
// //           selectedAddons: item.selectedAddons || [],
// //           appliedOffer: item.appliedOffer || null,
// //           isFree: false,
// //         };

// //         const qty = item.quantity || item.qty || 1;
// //         for (let i = 0; i < qty; i++) {
// //           dispatch(addItem(cartItem));
// //           loadedCount++;
// //         }
// //       });

// //       // if (loadedCount === 0) {
// //       //   setSnack({
// //       //     open: true,
// //       //     msg: "Koi item cart me load nahi hua.",
// //       //     type: "warning",
// //       //   });
// //       //   dispatch(setUpdateOrderId(null));
// //       //   return;
// //       // }

// //       // setSnack({
// //       //   open: true,
// //       //   msg: `${loadedCount} items cart me load ho gaye!`,
// //       //   type: "success",
// //       // });

// //       if (loadedCount === 0) {
// //         setSnack({
// //           open: true,
// //           msg: "No items could be loaded into the cart.",
// //           type: "warning",
// //         });
// //         dispatch(setUpdateOrderId(null));
// //         return;
// //       }

// //       setSnack({
// //         open: true,
// //         msg: `${loadedCount} ${loadedCount === 1 ? "item" : "items"} successfully loaded into cart!`,
// //         type: "success",
// //       });

// //       const urlIdentifier = restaurantInfo?.slug || restaurantId;
// //       setTimeout(() => {
// //         navigate(`/restaurant/${urlIdentifier}/menu?openCart=true`);
// //       }, 500);
// //     } catch (err) {
// //       console.error("Update click failed:", err);
// //       setSnack({
// //         open: true,
// //         msg: "Cart load failed",
// //         type: "error",
// //       });
// //     }
// //   };

// //   // PDF INVOICE DOWNLOAD
// //   const handleDownloadInvoice = (order) => {
// //     try {
// //       const doc = new jsPDF("p", "mm", "a4");
// //       const pageWidth = doc.internal.pageSize.getWidth();
// //       const pageHeight = doc.internal.pageSize.getHeight();

// //       const orderId = order._id || order.id;
// //       const shortId = orderId?.toString().slice(-8).toUpperCase();

// //       const restObj =
// //         typeof order.restaurant === "object" ? order.restaurant : {};
// //       const restaurantName =
// //         restObj.restaurantName ||
// //         restaurantInfo?.restaurantName ||
// //         "Restaurant";
// //       const restaurantAddress =
// //         restaurantInfo?.restaurantAddress ||
// //         restaurantInfo?.address ||
// //         restObj.restaurantAddress ||
// //         restObj.address ||
// //         "";
// //       const restaurantPhone =
// //         restaurantInfo?.mobile ||
// //         restaurantInfo?.whatsappNumber ||
// //         restObj.mobile ||
// //         restObj.whatsappNumber ||
// //         "";
// //       const restaurantCity = restaurantInfo?.city || restObj.city || "";
// //       const restaurantState = restaurantInfo?.state || restObj.state || "";

// //       const orderDate = order.createdAt
// //         ? new Date(order.createdAt).toLocaleString("en-IN", {
// //             day: "2-digit",
// //             month: "short",
// //             year: "numeric",
// //             hour: "2-digit",
// //             minute: "2-digit",
// //           })
// //         : "N/A";

// //       const orderTypeLabel =
// //         {
// //           DINE_IN: "Dine In",
// //           DELIVERY: "Delivery",
// //           TAKEAWAY: "Takeaway",
// //         }[order.orderType] || order.orderType;

// //       // HEADER
// //       doc.setFillColor(30, 70, 32);
// //       doc.rect(0, 0, pageWidth, 36, "F");

// //       doc.setTextColor(255, 255, 255);
// //       doc.setFontSize(20);
// //       doc.setFont("helvetica", "bold");
// //       doc.text(restaurantName.toUpperCase(), 14, 15);

// //       doc.setFontSize(8.5);
// //       doc.setFont("helvetica", "normal");
// //       let restLoc = [restaurantAddress, restaurantCity, restaurantState]
// //         .filter(Boolean)
// //         .join(", ");
// //       if (restLoc) {
// //         doc.text(doc.splitTextToSize(restLoc, 110), 14, 21);
// //       }
// //       if (restaurantPhone) {
// //         doc.text(`Contact: +91 ${restaurantPhone}`, 14, 30);
// //       }

// //       doc.setFontSize(16);
// //       doc.setFont("helvetica", "bold");
// //       doc.text("TAX INVOICE", pageWidth - 14, 15, { align: "right" });

// //       doc.setFontSize(8.5);
// //       doc.setFont("helvetica", "normal");
// //       doc.text(`Invoice No: #${shortId}`, pageWidth - 14, 22, {
// //         align: "right",
// //       });
// //       doc.text(`Date: ${orderDate}`, pageWidth - 14, 27, { align: "right" });
// //       doc.text(`Status: ${order.status || "PENDING"}`, pageWidth - 14, 32, {
// //         align: "right",
// //       });

// //       // CUSTOMER & ORDER BOX
// //       let yPos = 44;

// //       doc.setFillColor(248, 250, 252);
// //       doc.setDrawColor(226, 232, 240);
// //       doc.roundedRect(14, yPos, pageWidth - 28, 28, 2, 2, "FD");

// //       doc.setTextColor(30, 41, 59);
// //       doc.setFontSize(9);
// //       doc.setFont("helvetica", "bold");
// //       doc.text("CUSTOMER DETAILS:", 18, yPos + 6);

// //       doc.setFont("helvetica", "normal");
// //       doc.setFontSize(8.5);
// //       doc.text(
// //         `Name: ${order.customer?.name || "Guest Customer"}`,
// //         18,
// //         yPos + 12,
// //       );
// //       doc.text(`Phone: ${order.customer?.phone || "N/A"}`, 18, yPos + 17);
// //       if (order.customer?.address && order.orderType === "DELIVERY") {
// //         const addressLines = doc.splitTextToSize(
// //           `Address: ${order.customer.address}`,
// //           85,
// //         );
// //         doc.text(addressLines, 18, yPos + 22);
// //       }

// //       const rightColX = pageWidth / 2 + 10;
// //       doc.setFont("helvetica", "bold");
// //       doc.setFontSize(9);
// //       doc.text("ORDER INFORMATION:", rightColX, yPos + 6);

// //       doc.setFont("helvetica", "normal");
// //       doc.setFontSize(8.5);
// //       doc.text(`Order Type: ${orderTypeLabel}`, rightColX, yPos + 12);
// //       doc.text(
// //         `Table Number: ${order.tableNumber || "N/A"}`,
// //         rightColX,
// //         yPos + 17,
// //       );
// //       doc.text(
// //         `Payment Method: ${order.paymentMethod || "CASH"}`,
// //         rightColX,
// //         yPos + 22,
// //       );

// //       // ITEMS TABLE
// //       const tableStartY = yPos + 34;

// //       const regularItems = (order.items || []).filter((item) => {
// //         const isFree =
// //           item.isFree === true ||
// //           item.price === 0 ||
// //           item.itemName?.toLowerCase().includes("(free)") ||
// //           item.appliedOffer?.isFree === true ||
// //           item.appliedOffer?.offerCategory === "FREE_ITEM";
// //         return !isFree;
// //       });

// //       const itemsBody = regularItems.map((item, idx) => {
// //         const qty = Number(item.quantity || item.qty || 1);
// //         const originalPrice = Number(item.originalPrice || item.price || 0);
// //         const finalPrice = Number(item.price || 0);
// //         const discountAmount = Math.max(0, originalPrice - finalPrice);
// //         const total = Number(item.total || finalPrice * qty);

// //         let itemDesc = item.itemName || "Item";
// //         const meta = [
// //           item.selectedSize?.name && `Size: ${item.selectedSize.name}`,
// //           item.selectedVariant?.name && `Var: ${item.selectedVariant.name}`,
// //           item.selectedAddons?.length > 0 &&
// //             `Addons: ${item.selectedAddons.map((a) => a.name).join(", ")}`,
// //         ]
// //           .filter(Boolean)
// //           .join(" | ");

// //         if (meta) {
// //           itemDesc += `\n(${meta})`;
// //         }

// //         return [
// //           idx + 1,
// //           itemDesc,
// //           qty,
// //           `Rs. ${originalPrice.toFixed(2)}`,
// //           discountAmount > 0 ? `-Rs. ${discountAmount.toFixed(2)}` : "—",
// //           `Rs. ${finalPrice.toFixed(2)}`,
// //           `Rs. ${total.toFixed(2)}`,
// //         ];
// //       });

// //       const freeItemsMap = new Map();

// //       (order.freeItems || []).forEach((fi) => {
// //         const key = fi.itemName.replace(/\(FREE.*?\)/gi, "").trim();
// //         freeItemsMap.set(key, {
// //           name: key,
// //           quantity: fi.quantity || 1,
// //           price: Number(fi.price || fi.originalPrice || 0),
// //         });
// //       });

// //       (order.items || []).forEach((item) => {
// //         const isFree =
// //           item.isFree === true ||
// //           item.price === 0 ||
// //           item.itemName?.toLowerCase().includes("(free)") ||
// //           item.appliedOffer?.isFree === true;

// //         if (isFree) {
// //           const key = item.itemName.replace(/\(FREE.*?\)/gi, "").trim();
// //           if (!freeItemsMap.has(key)) {
// //             freeItemsMap.set(key, {
// //               name: key,
// //               quantity: item.quantity || 1,
// //               price: Number(item.originalPrice || item.price || 0),
// //             });
// //           }
// //         }
// //       });

// //       let currentIndex = regularItems.length;
// //       freeItemsMap.forEach((fi) => {
// //         currentIndex++;
// //         itemsBody.push([
// //           currentIndex,
// //           `${fi.name} [FREE OFFER]`,
// //           fi.quantity,
// //           `Rs. ${fi.price.toFixed(2)}`,
// //           "FREE",
// //           "Rs. 0.00",
// //           "Rs. 0.00",
// //         ]);
// //       });

// //       autoTable(doc, {
// //         startY: tableStartY,
// //         head: [
// //           [
// //             "#",
// //             "Item Description",
// //             "Qty",
// //             "Price",
// //             "Discount",
// //             "Net Rate",
// //             "Total",
// //           ],
// //         ],
// //         body: itemsBody,
// //         theme: "striped",
// //         headStyles: {
// //           fillColor: [46, 125, 50],
// //           textColor: [255, 255, 255],
// //           fontSize: 8.5,
// //           fontStyle: "bold",
// //           halign: "center",
// //         },
// //         bodyStyles: {
// //           fontSize: 8,
// //           textColor: [33, 37, 41],
// //           cellPadding: 2.5,
// //         },
// //         columnStyles: {
// //           0: { halign: "center", cellWidth: 10 },
// //           1: { cellWidth: "auto" },
// //           2: { halign: "center", cellWidth: 12 },
// //           3: { halign: "right", cellWidth: 22 },
// //           4: { halign: "right", cellWidth: 22, textColor: [46, 125, 50] },
// //           5: { halign: "right", cellWidth: 22 },
// //           6: { halign: "right", cellWidth: 25, fontStyle: "bold" },
// //         },
// //         alternateRowStyles: {
// //           fillColor: [248, 249, 250],
// //         },
// //         margin: { left: 14, right: 14 },
// //       });

// //       let finalY = doc.lastAutoTable.finalY + 6;

// //       const subtotal = Number(
// //         order.orderSummary?.subtotal ?? order.subtotal ?? 0,
// //       );
// //       const totalDiscount = Number(
// //         order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0,
// //       );
// //       const deliveryCharge = Number(
// //         order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
// //       );
// //       const totalAmount = Number(
// //         order.orderSummary?.totalAmount ?? order.total ?? 0,
// //       );
// //       const paidAmount = Number(
// //         order.orderSummary?.paidAmount ||
// //           (order.paymentStatus === "PAID" ? totalAmount : 0) ||
// //           0,
// //       );
// //       const balanceAmount = Number(order.orderSummary?.balanceAmount ?? 0);
// //       const refundDue = Number(order.orderSummary?.refundDue ?? 0);

// //       const hasOffers = order.appliedOffers && order.appliedOffers.length > 0;
// //       if (hasOffers) {
// //         doc.setFillColor(240, 253, 244);
// //         doc.setDrawColor(187, 247, 208);
// //         doc.roundedRect(14, finalY, 85, 28, 2, 2, "FD");

// //         doc.setFontSize(8.5);
// //         doc.setFont("helvetica", "bold");
// //         doc.setTextColor(22, 101, 52);
// //         doc.text("APPLIED OFFERS / DISCOUNTS:", 18, finalY + 5);

// //         doc.setFont("helvetica", "normal");
// //         doc.setFontSize(7.5);
// //         let offerY = finalY + 10;
// //         order.appliedOffers.slice(0, 3).forEach((off) => {
// //           doc.text(
// //             `• ${off.offerCode}: Save Rs. ${Number(
// //               off.discountAmount || 0,
// //             ).toFixed(2)}`,
// //             18,
// //             offerY,
// //           );
// //           offerY += 4;
// //         });
// //       }

// //       const summaryX = pageWidth - 90;
// //       let summaryY = finalY + 2;

// //       doc.setFontSize(8.5);
// //       doc.setFont("helvetica", "normal");
// //       doc.setTextColor(71, 85, 105);

// //       doc.text("Subtotal:", summaryX, summaryY);
// //       doc.text(`Rs. ${subtotal.toFixed(2)}`, pageWidth - 14, summaryY, {
// //         align: "right",
// //       });
// //       summaryY += 5;

// //       if (totalDiscount > 0) {
// //         doc.setTextColor(46, 125, 50);
// //         doc.text("Total Discounts:", summaryX, summaryY);
// //         doc.text(`-Rs. ${totalDiscount.toFixed(2)}`, pageWidth - 14, summaryY, {
// //           align: "right",
// //         });
// //         summaryY += 5;
// //       }

// //       if (order.orderType === "DELIVERY") {
// //         doc.setTextColor(71, 85, 105);
// //         doc.text("Delivery Charge:", summaryX, summaryY);
// //         doc.text(
// //           deliveryCharge === 0 ? "FREE" : `Rs. ${deliveryCharge.toFixed(2)}`,
// //           pageWidth - 14,
// //           summaryY,
// //           { align: "right" },
// //         );
// //         summaryY += 5;
// //       }

// //       doc.setDrawColor(203, 213, 225);
// //       doc.line(summaryX, summaryY, pageWidth - 14, summaryY);
// //       summaryY += 5;

// //       doc.setFontSize(11);
// //       doc.setFont("helvetica", "bold");
// //       doc.setTextColor(15, 23, 42);
// //       doc.text("Final Total:", summaryX, summaryY);
// //       doc.setTextColor(46, 125, 50);
// //       doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
// //         align: "right",
// //       });
// //       summaryY += 6;

// //       doc.setFontSize(8.5);
// //       doc.setFont("helvetica", "normal");
// //       doc.setTextColor(71, 85, 105);
// //       if (paidAmount > 0) {
// //         doc.text("Amount Paid:", summaryX, summaryY);
// //         doc.text(`Rs. ${paidAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
// //           align: "right",
// //         });
// //         summaryY += 5;
// //       }

// //       if (balanceAmount > 0) {
// //         doc.setFont("helvetica", "bold");
// //         doc.setTextColor(230, 81, 0);
// //         doc.text("Remaining Balance:", summaryX, summaryY);
// //         doc.text(`Rs. ${balanceAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
// //           align: "right",
// //         });
// //         summaryY += 5;
// //       }

// //       if (refundDue > 0) {
// //         const boxHeight = 16;
// //         const boxY = summaryY - 0;

// //         doc.setFillColor(255, 248, 240);
// //         doc.setDrawColor(230, 81, 0);
// //         doc.roundedRect(14, boxY, pageWidth - 28, boxHeight, 2, 2, "FD");

// //         doc.setFontSize(9);
// //         doc.setFont("helvetica", "bold");
// //         doc.setTextColor(230, 81, 0);
// //         doc.text("REFUND DUE FROM RESTAURANT", 18, boxY + 6);

// //         doc.setFontSize(11);
// //         doc.text(`Rs. ${refundDue.toFixed(2)}`, pageWidth - 18, boxY + 6, {
// //           align: "right",
// //         });

// //         doc.setFontSize(7.5);
// //         doc.setFont("helvetica", "italic");
// //         doc.setTextColor(120, 80, 40);
// //         doc.text(
// //           "Restaurant will settle this amount via direct UPI or Cash refund",
// //           18,
// //           boxY + 12,
// //         );

// //         summaryY = boxY + boxHeight + 6;
// //       }

// //       const footerY = pageHeight - 16;
// //       doc.setDrawColor(226, 232, 240);
// //       doc.line(14, footerY - 4, pageWidth - 14, footerY - 4);

// //       doc.setFontSize(7.5);
// //       doc.setFont("helvetica", "italic");
// //       doc.setTextColor(148, 163, 184);
// //       doc.text(
// //         "Thank you for dining with us! Powered by RestaurantWala",
// //         pageWidth / 2,
// //         footerY,
// //         { align: "center" },
// //       );
// //       doc.setFontSize(6.5);
// //       doc.text(
// //         `Computer generated receipt • Generated on ${new Date().toLocaleString(
// //           "en-IN",
// //         )}`,
// //         pageWidth / 2,
// //         footerY + 4,
// //         { align: "center" },
// //       );

// //       doc.save(`Invoice_${restaurantName.replace(/\s+/g, "_")}_${shortId}.pdf`);

// //       setSnack({
// //         open: true,
// //         msg: "Invoice downloaded successfully! 📄",
// //         type: "success",
// //       });
// //     } catch (err) {
// //       console.error("PDF generation failed:", err);
// //       setSnack({
// //         open: true,
// //         msg: "Failed to download invoice",
// //         type: "error",
// //       });
// //     }
// //   };

// //   // ⭐ Full-page spinner ONLY on very first load
// //   if (loading && filteredOrders.length === 0) {
// //     return (
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "center",
// //           alignItems: "center",
// //           height: "60vh",
// //         }}
// //       >
// //         <CircularProgress sx={{ color: "var(--primary, #FF6B00)" }} />
// //       </Box>
// //     );
// //   }

// //   const isEmpty = filteredOrders.length === 0;

// //   return (
// //     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 6 }}>
// //       <Box sx={{ px: { xs: 1.5, sm: 2 }, pt: 2 }}>
// //         {/* Header */}
// //         <Box
// //           sx={{
// //             display: "flex",
// //             justifyContent: "end",
// //             alignItems: "center",
// //             mb: 1.5,
// //           }}
// //         >
// //           {/* <Typography
// //             variant="subtitle1"
// //             sx={{ fontWeight: 800, color: "#1a1a1a" }}
// //           >
// //             My Orders ({filteredOrders.length}
// //             {orders.length > filteredOrders.length ? `/${orders.length}` : ""})
// //           </Typography> */}
// //           <Button
// //             size="small"
// //             variant="text"
// //             onClick={() =>
// //               getMyOrders({ page: 1, limit: PAGE_SIZE, append: false })
// //             }
// //             startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
// //             sx={{
// //               textTransform: "none",
// //               color: "var(--primary, #FF6B00)",
// //               fontWeight: 700,
// //               fontSize: "0.75rem",
// //             }}
// //           >
// //             Refresh
// //           </Button>
// //         </Box>

// //         {/* Empty state */}
// //         {isEmpty && !loading && (
// //           <Box sx={{ textAlign: "center", py: 8 }}>
// //             <Box
// //               sx={{
// //                 width: 72,
// //                 height: 72,
// //                 borderRadius: "50%",
// //                 bgcolor: "#fff3e0",
// //                 mx: "auto",
// //                 mb: 2,
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //               }}
// //             >
// //               <ReceiptLongIcon
// //                 sx={{ fontSize: 36, color: "var(--primary, #FF6B00)" }}
// //               />
// //             </Box>
// //             <Typography
// //               variant="subtitle1"
// //               sx={{ fontWeight: 700, color: "#333", mb: 0.5 }}
// //             >
// //               No orders yet
// //             </Typography>
// //             <Typography
// //               variant="caption"
// //               sx={{ color: "#888", display: "block", mb: 2 }}
// //             >
// //               Place your first order from the menu!
// //             </Typography>
// //             <Button
// //               variant="outlined"
// //               size="small"
// //               onClick={() => {
// //                 const targetId = restaurantInfo?.slug || restaurantId;
// //                 navigate(`/restaurant/${targetId}/menu`);
// //               }}
// //               sx={{
// //                 borderColor: "var(--primary, #FF6B00)",
// //                 color: "var(--primary, #FF6B00)",
// //                 borderRadius: 2,
// //                 textTransform: "none",
// //                 fontWeight: 600,
// //               }}
// //             >
// //               Browse Menu
// //             </Button>
// //           </Box>
// //         )}

// //         {/* Orders list */}
// //         {filteredOrders.map((order, index) => {
// //           const isPending = order.status === "PENDING";
// //           const orderId = order._id || order.id;
// //           const shortId = orderId?.toString().slice(-8).toUpperCase();
// //           const freeItemsValue =
// //             order.freeItems?.reduce(
// //               (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
// //               0,
// //             ) || 0;
// //           const subtotal = order.orderSummary?.subtotal ?? order.subtotal ?? 0;
// //           const totalDiscount =
// //             order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0;
// //           const deliveryCharge = Number(
// //             order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
// //           );
// //           const total = order.orderSummary?.totalAmount ?? order.total ?? 0;

// //           const paidAmount = Number(order.orderSummary?.paidAmount || 0);
// //           const refundDue = Number(
// //             order.orderSummary?.refundDue ??
// //               (paidAmount > total && total > 0 ? paidAmount - total : 0),
// //           );

// //           return (
// //             <Paper
// //               key={orderId || index}
// //               elevation={0}
// //               sx={{
// //                 borderRadius: 3,
// //                 bgcolor: "white",
// //                 border: "1px solid #f0f0f0",
// //                 mb: 1.5,
// //                 overflow: "hidden",
// //                 boxShadow:
// //                   index === 0
// //                     ? "0 2px 12px rgba(255,107,0,0.12)"
// //                     : "0 1px 4px rgba(0,0,0,0.06)",
// //               }}
// //             >
// //               {index === 0 && (
// //                 <Box
// //                   sx={{
// //                     bgcolor: "rgba(255,107,0,0.08)",
// //                     px: 2,
// //                     py: 0.6,
// //                     display: "flex",
// //                     alignItems: "center",
// //                     gap: 0.8,
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       width: 6,
// //                       height: 6,
// //                       borderRadius: "50%",
// //                       bgcolor: "var(--primary, #FF6B00)",
// //                       animation: "pulse 1.5s infinite",
// //                     }}
// //                   />
// //                   <Typography
// //                     variant="caption"
// //                     sx={{
// //                       color: "var(--primary, #FF6B00)",
// //                       fontWeight: 700,
// //                       fontSize: "0.72rem",
// //                     }}
// //                   >
// //                     Latest Order
// //                   </Typography>
// //                 </Box>
// //               )}

// //               <Box sx={{ p: 2 }}>
// //                 {/* Header */}
// //                 <Box
// //                   sx={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     alignItems: "flex-start",
// //                     mb: 1.2,
// //                   }}
// //                 >
// //                   <Box>
// //                     <Typography
// //                       variant="body2"
// //                       sx={{
// //                         fontWeight: 700,
// //                         fontSize: "0.85rem",
// //                         color: "#1a1a1a",
// //                       }}
// //                     >
// //                       Order #{shortId}
// //                     </Typography>
// //                     <Box
// //                       sx={{
// //                         display: "flex",
// //                         alignItems: "center",
// //                         gap: 0.5,
// //                         mt: 0.3,
// //                       }}
// //                     >
// //                       <AccessTimeIcon sx={{ fontSize: 12, color: "#aaa" }} />
// //                       <Typography
// //                         variant="caption"
// //                         sx={{ color: "#aaa", fontSize: "0.7rem" }}
// //                       >
// //                         {order.createdAt
// //                           ? new Date(order.createdAt).toLocaleString("en-IN", {
// //                               day: "numeric",
// //                               month: "short",
// //                               hour: "2-digit",
// //                               minute: "2-digit",
// //                             })
// //                           : "Recently"}
// //                       </Typography>
// //                     </Box>
// //                   </Box>
// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       flexDirection: "column",
// //                       alignItems: "flex-end",
// //                       gap: 0.5,
// //                     }}
// //                   >
// //                     <OrderTypeLabel type={order.orderType} />
// //                     <StatusChip status={order.status} />
// //                   </Box>
// //                 </Box>

// //                 <Divider sx={{ mb: 1.2 }} />

// //                 <OrderItems
// //                   items={order.items}
// //                   freeItems={order.freeItems}
// //                   freeItemsValue={freeItemsValue}
// //                 />

// //                 {/* Summary */}
// //                 <Box sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #f0f0f0" }}>
// //                   <Typography
// //                     variant="caption"
// //                     sx={{
// //                       fontWeight: 700,
// //                       color: "#333",
// //                       mb: 1,
// //                       display: "block",
// //                       fontSize: "0.75rem",
// //                       textTransform: "uppercase",
// //                       letterSpacing: 0.5,
// //                     }}
// //                   >
// //                     Order Summary
// //                   </Typography>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 0.5,
// //                     }}
// //                   >
// //                     <Typography
// //                       variant="caption"
// //                       sx={{ color: "#666", fontSize: "0.78rem" }}
// //                     >
// //                       Subtotal
// //                     </Typography>
// //                     <Typography
// //                       variant="caption"
// //                       sx={{ fontWeight: 600, fontSize: "0.78rem" }}
// //                     >
// //                       ₹{Number(subtotal).toFixed(2)}
// //                     </Typography>
// //                   </Box>

// //                   {totalDiscount > 0 && (
// //                     <Box
// //                       sx={{
// //                         display: "flex",
// //                         justifyContent: "space-between",
// //                         mb: 0.5,
// //                       }}
// //                     >
// //                       <Typography
// //                         variant="caption"
// //                         sx={{ color: "#2e7d32", fontSize: "0.78rem" }}
// //                       >
// //                         Total discounts
// //                       </Typography>
// //                       <Typography
// //                         variant="caption"
// //                         sx={{
// //                           color: "#2e7d32",
// //                           fontWeight: 700,
// //                           fontSize: "0.78rem",
// //                         }}
// //                       >
// //                         -₹{Number(totalDiscount).toFixed(2)}
// //                       </Typography>
// //                     </Box>
// //                   )}

// //                   {order.orderType === "DELIVERY" && (
// //                     <Box
// //                       sx={{
// //                         display: "flex",
// //                         justifyContent: "space-between",
// //                         mb: 0.5,
// //                       }}
// //                     >
// //                       <Typography
// //                         variant="caption"
// //                         sx={{ color: "#666", fontSize: "0.78rem" }}
// //                       >
// //                         Delivery Charge
// //                       </Typography>
// //                       <Typography
// //                         variant="caption"
// //                         sx={{
// //                           fontWeight: 700,
// //                           fontSize: "0.78rem",
// //                           color: deliveryCharge === 0 ? "#2e7d32" : "#1a1a1a",
// //                         }}
// //                       >
// //                         {deliveryCharge === 0
// //                           ? "FREE"
// //                           : `₹${deliveryCharge.toFixed(2)}`}
// //                       </Typography>
// //                     </Box>
// //                   )}

// //                   <Divider sx={{ my: 0.8 }} />

// //                   <Box
// //                     sx={{ display: "flex", justifyContent: "space-between" }}
// //                   >
// //                     <Typography
// //                       variant="body2"
// //                       sx={{ fontWeight: 700, fontSize: "0.85rem" }}
// //                     >
// //                       Total
// //                     </Typography>
// //                     <Typography
// //                       variant="body2"
// //                       sx={{
// //                         fontWeight: 800,
// //                         color: "#2e7d32",
// //                         fontSize: "0.9rem",
// //                       }}
// //                     >
// //                       ₹{Number(total).toFixed(2)}
// //                     </Typography>
// //                   </Box>

// //                   {order.status === "CANCELLED" &&
// //                     Number(order.orderSummary?.refundDue || 0) > 0 && (
// //                       <Box
// //                         sx={{
// //                           mt: 1.2,
// //                           p: 1.2,
// //                           bgcolor: "#fff3e0",
// //                           borderRadius: 2,
// //                           border: "1px dashed #e65100",
// //                           display: "flex",
// //                           justifyContent: "space-between",
// //                           alignItems: "center",
// //                         }}
// //                       >
// //                         <Box>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{
// //                               fontWeight: 800,
// //                               color: "#e65100",
// //                               display: "block",
// //                             }}
// //                           >
// //                             ⏳ Refund Pending from Restaurant:
// //                           </Typography>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{ color: "#666", fontSize: "0.68rem" }}
// //                           >
// //                             Order was cancelled. The restaurant will refund ₹
// //                             {Number(order.orderSummary.refundDue).toFixed(2)} to
// //                             your UPI.
// //                           </Typography>
// //                         </Box>
// //                         <Typography
// //                           variant="body2"
// //                           sx={{ fontWeight: 900, color: "#e65100" }}
// //                         >
// //                           ₹{Number(order.orderSummary.refundDue).toFixed(2)}
// //                         </Typography>
// //                       </Box>
// //                     )}

// //                   {order.paymentStatus === "REFUNDED" && (
// //                     <Box
// //                       sx={{
// //                         mt: 1.2,
// //                         p: 1,
// //                         bgcolor: "#e8f5e9",
// //                         borderRadius: 2,
// //                         border: "1px solid #a5d6a7",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         gap: 1,
// //                       }}
// //                     >
// //                       <Typography
// //                         variant="caption"
// //                         sx={{ fontWeight: 700, color: "#2e7d32" }}
// //                       >
// //                         Refund Completed: Restaurant has settled your refund
// //                         amount.
// //                       </Typography>
// //                     </Box>
// //                   )}

// //                   {totalDiscount > 0 && (
// //                     <Typography
// //                       variant="caption"
// //                       sx={{
// //                         display: "block",
// //                         textAlign: "right",
// //                         color: "#2e7d32",
// //                         mt: 0.5,
// //                         fontSize: "0.7rem",
// //                         fontWeight: 600,
// //                       }}
// //                     >
// //                       🎉 You saved ₹{Number(totalDiscount).toFixed(2)}!
// //                     </Typography>
// //                   )}
// //                 </Box>

// //                 {/* Actions */}
// //                 <Box
// //                   sx={{ display: "flex", gap: 1, mt: 1.5, flexWrap: "wrap" }}
// //                 >
// //                   <Button
// //                     size="small"
// //                     variant="outlined"
// //                     startIcon={<WhatsAppIcon sx={{ fontSize: 16 }} />}
// //                     onClick={() => {
// //                       const restaurantPhone =
// //                         typeof order.restaurant === "object"
// //                           ? order.restaurant?.whatsappNumber
// //                           : restaurantInfo?.whatsappNumber;
// //                       const fallbackPhone = "917734904014";
// //                       const phone = restaurantPhone || fallbackPhone;
// //                       const message = `Hi, I'd like to follow up on my order #${shortId}`;
// //                       window.open(
// //                         `https://wa.me/${phone}?text=${encodeURIComponent(
// //                           message,
// //                         )}`,
// //                         "_blank",
// //                       );
// //                     }}
// //                     sx={{
// //                       borderColor: "#25D366",
// //                       color: "#25D366",
// //                       "&:hover": {
// //                         bgcolor: "#f0fff4",
// //                         borderColor: "#128C7E",
// //                       },
// //                       borderRadius: 2,
// //                       textTransform: "none",
// //                       fontWeight: 600,
// //                       fontSize: "0.78rem",
// //                       flex: 1,
// //                       minWidth: 100,
// //                     }}
// //                   >
// //                     WhatsApp
// //                   </Button>

// //                   <Button
// //                     size="small"
// //                     variant="outlined"
// //                     startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
// //                     onClick={() => handleDownloadInvoice(order)}
// //                     sx={{
// //                       borderRadius: 2,
// //                       textTransform: "none",
// //                       fontWeight: 600,
// //                       fontSize: "0.78rem",
// //                       flex: 1,
// //                       minWidth: 100,
// //                       borderColor: "#2e7d32",
// //                       color: "#2e7d32",
// //                       "&:hover": {
// //                         bgcolor: "#e8f5e9",
// //                         borderColor: "#1b5e20",
// //                       },
// //                     }}
// //                   >
// //                     Invoice
// //                   </Button>

// //                   {isPending && (
// //                     <Button
// //                       size="small"
// //                       variant="outlined"
// //                       color="primary"
// //                       startIcon={<EditIcon sx={{ fontSize: 16 }} />}
// //                       onClick={() => handleUpdateClick(order)}
// //                       sx={{
// //                         borderRadius: 2,
// //                         textTransform: "none",
// //                         fontWeight: 600,
// //                         fontSize: "0.78rem",
// //                         flex: 1,
// //                         minWidth: 100,
// //                       }}
// //                     >
// //                       Update
// //                     </Button>
// //                   )}

// //                   {isPending && (
// //                     <Button
// //                       size="small"
// //                       variant="outlined"
// //                       color="error"
// //                       startIcon={<CancelIcon sx={{ fontSize: 16 }} />}
// //                       onClick={() => handleCancelClick(order)}
// //                       sx={{
// //                         borderRadius: 2,
// //                         textTransform: "none",
// //                         fontWeight: 600,
// //                         fontSize: "0.78rem",
// //                         flex: 1,
// //                         minWidth: 100,
// //                       }}
// //                     >
// //                       Cancel
// //                     </Button>
// //                   )}
// //                 </Box>
// //               </Box>
// //             </Paper>
// //           );
// //         })}

// //         {/* ⭐ Infinite scroll sentinel / End-of-list marker */}
// //         {!isEmpty && (
// //           <Box
// //             ref={loadMoreRef}
// //             sx={{
// //               display: "flex",
// //               justifyContent: "center",
// //               alignItems: "center",
// //               py: 3,
// //               minHeight: 60,
// //             }}
// //           >
// //             {loadingMore && (
// //               <CircularProgress
// //                 size={28}
// //                 sx={{ color: "var(--primary, #FF6B00)" }}
// //               />
// //             )}
// //             {!hasMore && filteredOrders.length > 0 && (
// //               <Typography
// //                 variant="caption"
// //                 sx={{
// //                   color: "#aaa",
// //                   fontSize: "0.72rem",
// //                   fontWeight: 600,
// //                   letterSpacing: 0.4,
// //                 }}
// //               >
// //                 {/* — End of orders — */}
// //               </Typography>
// //             )}
// //           </Box>
// //         )}
// //       </Box>

// //       {/* Cancel Dialog */}
// //       <Dialog
// //         open={cancelDialog.open}
// //         onClose={() => setCancelDialog({ open: false, order: null })}
// //         maxWidth="xs"
// //         fullWidth
// //       >
// //         <DialogTitle sx={{ fontWeight: 700, color: "#c62828" }}>
// //           Cancel Order?
// //         </DialogTitle>
// //         <DialogContent>
// //           <Typography variant="body2" sx={{ mb: 2 }}>
// //             Are you sure you want to cancel order #
// //             {(cancelDialog.order?._id || cancelDialog.order?.id)
// //               ?.toString()
// //               .slice(-8)
// //               .toUpperCase()}
// //             ?
// //           </Typography>
// //           <TextField
// //             fullWidth
// //             size="small"
// //             label="Reason (optional)"
// //             value={cancelReason}
// //             onChange={(e) => setCancelReason(e.target.value)}
// //             multiline
// //             rows={2}
// //             placeholder="e.g. Changed my mind"
// //           />
// //         </DialogContent>
// //         <DialogActions sx={{ px: 3, pb: 2 }}>
// //           <Button onClick={() => setCancelDialog({ open: false, order: null })}>
// //             No, Keep it
// //           </Button>
// //           <Button
// //             onClick={handleCancelConfirm}
// //             color="error"
// //             variant="contained"
// //           >
// //             Yes, Cancel
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Snackbar */}
// //       <Snackbar
// //         open={snack.open}
// //         autoHideDuration={3000}
// //         onClose={() => setSnack((s) => ({ ...s, open: false }))}
// //         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
// //         sx={{ bottom: 70 }}
// //       >
// //         <Alert severity={snack.type} variant="filled" sx={{ borderRadius: 2 }}>
// //           {snack.msg}
// //         </Alert>
// //       </Snackbar>

// //       <style>
// //         {`
// //           @keyframes pulse {
// //             0%, 100% { opacity: 1; transform: scale(1); }
// //             50% { opacity: 0.5; transform: scale(1.2); }
// //           }
// //         `}
// //       </style>
// //     </Box>
// //   );
// // };

// // export default OrdersPage;

// import React, {
//   useState,
//   useEffect,
//   useMemo,
//   useRef,
//   useCallback,
// } from "react";
// import {
//   Box,
//   Typography,
//   Paper,
//   Chip,
//   Button,
//   Divider,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   TextField,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import RestaurantIcon from "@mui/icons-material/Restaurant";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import EditIcon from "@mui/icons-material/Edit";
// import CancelIcon from "@mui/icons-material/Cancel";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import StarIcon from "@mui/icons-material/Star";
// import { useMyOrders } from "../../../hooks/useMyOrders";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   addItem,
//   clearCart,
//   setRestaurant,
//   selectCartRestaurant,
//   setUpdateOrderId,
// } from "../../../redux/slices/cartSlice";
// import { updateCartCalculation } from "../../../redux/slices/publicSlice";
// import { useSocket } from "../../../context/SocketContext";
// import { setupPushNotifications } from "../../../utils/pushNotifications";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import DownloadIcon from "@mui/icons-material/Download";

// const PAGE_SIZE = 8; // ⭐ 8 orders per page

// // ========== OrderType Components ==========
// const OrderTypeIcon = ({ type }) => {
//   const icons = {
//     DINE_IN: <RestaurantIcon sx={{ fontSize: 16, color: "#2e7d32", ml: 1 }} />,
//     DELIVERY: (
//       <LocalShippingIcon sx={{ fontSize: 16, color: "#1976d2", ml: 1 }} />
//     ),
//     TAKEAWAY: (
//       <TakeoutDiningIcon sx={{ fontSize: 16, color: "#e65100", ml: 1 }} />
//     ),
//   };
//   return icons[type] || icons.DINE_IN;
// };

// const OrderTypeLabel = ({ type }) => {
//   const labels = {
//     DINE_IN: "Dine In",
//     DELIVERY: "Delivery",
//     TAKEAWAY: "Takeaway",
//   };
//   const colors = {
//     DINE_IN: "#2e7d32",
//     DELIVERY: "#1976d2",
//     TAKEAWAY: "#e65100",
//   };
//   return (
//     <Chip
//       label={labels[type] || type}
//       size="small"
//       icon={<OrderTypeIcon type={type} />}
//       sx={{
//         height: 22,
//         fontSize: "0.65rem",
//         fontWeight: 600,
//         bgcolor: `${colors[type] || "#2e7d32"}15`,
//         color: colors[type] || "#2e7d32",
//         border: `1px solid ${colors[type] || "#2e7d32"}40`,
//         "& .MuiChip-icon": { fontSize: 14 },
//       }}
//     />
//   );
// };

// // Status Chip
// const StatusChip = ({ status }) => {
//   const colors = {
//     PENDING: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
//     ACCEPTED: { bg: "#e3f2fd", color: "#1565c0", border: "#64b5f6" },
//     PREPARING: { bg: "#f3e5f5", color: "#6a1b9a", border: "#ba68c8" },
//     OUT_FOR_DELIVERY: { bg: "#fff8e1", color: "#f57f17", border: "#ffd54f" },
//     COMPLETED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
//     DELIVERED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
//     CANCELLED: { bg: "#ffebee", color: "#c62828", border: "#ef9a9a" },
//   };
//   const c = colors[status] || colors.PENDING;
//   return (
//     <Chip
//       label={status}
//       size="small"
//       sx={{
//         height: 20,
//         fontSize: "0.62rem",
//         fontWeight: 700,
//         bgcolor: c.bg,
//         color: c.color,
//         border: `1px solid ${c.border}`,
//       }}
//     />
//   );
// };

// // ========== OrderItems ==========
// const OrderItems = ({ items, freeItems }) => {
//   const [expanded, setExpanded] = useState(false);
//   const initialDisplay = 3;
//   const hasMoreItems = items?.length > initialDisplay;
//   const displayItems = expanded ? items : items?.slice(0, initialDisplay) || [];

//   return (
//     <Box>
//       <Box sx={{ mb: 1.2 }}>
//         {items && items.length > 0 ? (
//           <>
//             {displayItems.map((item, i) => {
//               const isFree =
//                 item.isFree ||
//                 item.price === 0 ||
//                 item.itemName?.includes("FREE");
//               return (
//                 <Box key={i}>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       mb: 0.4,
//                       opacity: isFree ? 0.8 : 1,
//                     }}
//                   >
//                     <Box sx={{ flex: 1 }}>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color: isFree ? "#888" : "#555",
//                           fontSize: "0.78rem",
//                           textDecoration: isFree ? "line-through" : "none",
//                         }}
//                       >
//                         {item.itemName} × {item.quantity}
//                         {isFree && (
//                           <Chip
//                             label="FREE"
//                             size="small"
//                             sx={{
//                               ml: 1,
//                               height: 16,
//                               fontSize: "0.5rem",
//                               bgcolor: "#e8f5e9",
//                               color: "#2e7d32",
//                               fontWeight: 700,
//                             }}
//                           />
//                         )}
//                       </Typography>
//                       {item.appliedOffer && !isFree && (
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             color: "#2e7d32",
//                             fontSize: "0.65rem",
//                             display: "block",
//                             mt: 0.2,
//                           }}
//                         >
//                           🏷 {item.appliedOffer.offerCode} Saved ₹
//                           {(
//                             (item.originalPrice - item.price) *
//                             item.quantity
//                           ).toFixed(0)}
//                         </Typography>
//                       )}
//                       {(item.selectedSize ||
//                         item.selectedVariant ||
//                         item.selectedAddons?.length > 0) && (
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             color: "#999",
//                             fontSize: "0.6rem",
//                             display: "block",
//                             mt: 0.1,
//                           }}
//                         >
//                           {[
//                             item.selectedSize?.name &&
//                               `Size: ${item.selectedSize.name}`,
//                             item.selectedVariant?.name &&
//                               `Variant: ${item.selectedVariant.name}`,
//                             item.selectedAddons?.length > 0 &&
//                               `Addons: ${item.selectedAddons
//                                 .map((a) => a.name)
//                                 .join(", ")}`,
//                           ]
//                             .filter(Boolean)
//                             .join(" · ")}
//                         </Typography>
//                       )}
//                     </Box>
//                     <Box sx={{ textAlign: "right" }}>
//                       {isFree ? (
//                         <Chip
//                           label="FREE"
//                           size="small"
//                           sx={{
//                             height: 16,
//                             fontSize: "0.55rem",
//                             bgcolor: "#e8f5e9",
//                             color: "#2e7d32",
//                             fontWeight: 700,
//                           }}
//                         />
//                       ) : item.appliedOffer ? (
//                         <>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: "#999",
//                               textDecoration: "line-through",
//                               fontSize: "0.7rem",
//                               display: "block",
//                             }}
//                           >
//                             ₹{(item.originalPrice * item.quantity).toFixed(0)}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: "#2e7d32",
//                               fontWeight: 600,
//                               fontSize: "0.78rem",
//                             }}
//                           >
//                             ₹{(item.price * item.quantity).toFixed(0)}
//                           </Typography>
//                         </>
//                       ) : (
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             color: "#333",
//                             fontWeight: 600,
//                             fontSize: "0.78rem",
//                           }}
//                         >
//                           ₹{(item.price * item.quantity).toFixed(0)}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 </Box>
//               );
//             })}

//             {hasMoreItems && (
//               <Button
//                 size="small"
//                 onClick={() => setExpanded(!expanded)}
//                 endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                 sx={{
//                   mt: 0.5,
//                   fontSize: "0.7rem",
//                   fontWeight: 600,
//                   color: "#2e7d32",
//                   textTransform: "none",
//                   "&:hover": { bgcolor: "#e8f5e9" },
//                 }}
//               >
//                 {expanded
//                   ? `Show Less (${items.length} items)`
//                   : `Show ${items.length - initialDisplay} more item${
//                       items.length - initialDisplay !== 1 ? "s" : ""
//                     }`}
//               </Button>
//             )}
//           </>
//         ) : (
//           <Typography
//             variant="caption"
//             sx={{ color: "#999", fontStyle: "italic" }}
//           >
//             No items to display
//           </Typography>
//         )}
//       </Box>

//       {freeItems && freeItems.length > 0 && (
//         <Box
//           sx={{
//             mb: 1,
//             bgcolor: "#e8f5e9",
//             p: 1,
//             borderRadius: 1,
//             border: "1px solid #c8e6c9",
//           }}
//         >
//           <Typography
//             variant="caption"
//             sx={{
//               color: "#2e7d32",
//               fontWeight: 700,
//               fontSize: "0.75rem",
//               display: "block",
//               mb: 0.5,
//             }}
//           >
//             🎁 Free Items from Offers
//           </Typography>
//           {freeItems.map((item, i) => (
//             <Box
//               key={i}
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 0.3,
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#555", fontSize: "0.78rem" }}
//               >
//                 {item.itemName} × {item.quantity}
//               </Typography>
//               <Chip
//                 label={`FREE (₹${(item.price * item.quantity).toFixed(
//                   0,
//                 )} saved)`}
//                 size="small"
//                 sx={{
//                   height: 18,
//                   fontSize: "0.55rem",
//                   bgcolor: "#2e7d32",
//                   color: "white",
//                 }}
//               />
//             </Box>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ========== MAIN OrdersPage ==========
// const OrdersPage = ({ restaurantId, restaurantInfo }) => {
//   const {
//     orders = [],
//     loading,
//     loadingMore,
//     hasMore,
//     currentPage,
//     error,
//     getMyOrders,
//     updateMyOrder,
//     cancelMyOrder,
//     clearError,
//   } = useMyOrders();

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { socket } = useSocket();
//   const cartRestaurant = useSelector(selectCartRestaurant);

//   const [snack, setSnack] = useState({ open: false, msg: "", type: "success" });
//   const [cancelDialog, setCancelDialog] = useState({
//     open: false,
//     order: null,
//   });
//   const [cancelReason, setCancelReason] = useState("");
//   const [reviewModal, setReviewModal] = useState({
//     open: false,
//     order: null,
//   });

//   const loadMoreRef = useRef(null);

//   const refreshLoadedOrders = useCallback(() => {
//     const safePage = currentPage || 1;
//     const limit = Math.max(PAGE_SIZE, safePage * PAGE_SIZE);
//     getMyOrders({ page: 1, limit, append: false });
//   }, [getMyOrders, currentPage]);

//   useEffect(() => {
//     getMyOrders({ page: 1, limit: PAGE_SIZE, append: false });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [restaurantId]);

//   useEffect(() => {
//     if (restaurantId) {
//       setupPushNotifications(restaurantId);
//     }
//   }, [restaurantId]);

//   useEffect(() => {
//     if (!socket) return;
//     const handleUpdate = () => refreshLoadedOrders();
//     socket.on("order-status-updated", handleUpdate);
//     socket.on("new-order", handleUpdate);
//     return () => {
//       socket.off("order-status-updated", handleUpdate);
//       socket.off("new-order", handleUpdate);
//     };
//   }, [socket, refreshLoadedOrders]);

//   useEffect(() => {
//     if (error) {
//       setSnack({ open: true, msg: error, type: "error" });
//       clearError();
//     }
//   }, [error, clearError]);

//   const filteredOrders = useMemo(() => {
//     if (!orders || orders.length === 0) return [];

//     const currentSlug =
//       restaurantInfo?.slug ||
//       (restaurantId?.length !== 24 ? restaurantId : null);
//     const currentObjectId =
//       restaurantInfo?._id?.toString() ||
//       (restaurantId?.length === 24 ? restaurantId : null);

//     return orders.filter((o) => {
//       const rest = o.restaurant || {};
//       const restId = (rest._id || rest.id || rest).toString();
//       const restSlug = rest.slug;

//       if (currentSlug && restSlug && restSlug === currentSlug) return true;
//       if (currentSlug && restId === currentSlug) return true;
//       if (currentObjectId && restId === currentObjectId) return true;
//       if (restId === restaurantId || restSlug === restaurantId) return true;

//       return false;
//     });
//   }, [orders, restaurantId, restaurantInfo]);

//   useEffect(() => {
//     if (!hasMore || loading || loadingMore) return;
//     const node = loadMoreRef.current;
//     if (!node) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0]?.isIntersecting) {
//           getMyOrders({
//             page: (currentPage || 1) + 1,
//             limit: PAGE_SIZE,
//             append: true,
//           });
//         }
//       },
//       { rootMargin: "200px 0px" },
//     );

//     observer.observe(node);
//     return () => observer.disconnect();
//   }, [hasMore, loading, loadingMore, currentPage, getMyOrders]);

//   const handleCancelClick = (order) => {
//     setCancelDialog({ open: true, order });
//     setCancelReason("");
//   };

//   const handleCancelConfirm = async () => {
//     try {
//       await cancelMyOrder(
//         cancelDialog.order._id || cancelDialog.order.id,
//         cancelReason,
//       );
//       setSnack({
//         open: true,
//         msg: "Order cancelled successfully",
//         type: "success",
//       });
//       refreshLoadedOrders();
//     } catch (err) {
//       setSnack({
//         open: true,
//         msg: err?.message || "Cancel failed",
//         type: "error",
//       });
//     } finally {
//       setCancelDialog({ open: false, order: null });
//       setCancelReason("");
//     }
//   };

//   const checkAndTriggerReview = (ordersList) => {
//     if (!ordersList || ordersList.length === 0) return;

//     const unratedCompletedOrder = ordersList.find((o) => {
//       const isDone = o.status === "COMPLETED" || o.status === "DELIVERED";
//       const orderId = o._id || o.id;
//       const alreadyRated = localStorage.getItem(`rated_order_${orderId}`);
//       return isDone && !alreadyRated;
//     });

//     if (unratedCompletedOrder) {
//       setReviewModal({
//         open: true,
//         order: unratedCompletedOrder,
//       });
//     }
//   };

//   useEffect(() => {
//     if (filteredOrders.length > 0) {
//       checkAndTriggerReview(filteredOrders);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [filteredOrders]);

//   useEffect(() => {
//     if (!socket) return;
//     const handleUpdate = (data) => {
//       refreshLoadedOrders();
//       if (data?.order) {
//         const orderStatus = data.order.status;
//         const orderId = data.order._id || data.order.id;
//         const alreadyRated = localStorage.getItem(`rated_order_${orderId}`);
//         if (
//           (orderStatus === "COMPLETED" || orderStatus === "DELIVERED") &&
//           !alreadyRated
//         ) {
//           setReviewModal({
//             open: true,
//             order: data.order,
//           });
//         }
//       }
//     };

//     socket.on("order-status-updated", handleUpdate);
//     socket.on("new-order", handleUpdate);
//     return () => {
//       socket.off("order-status-updated", handleUpdate);
//       socket.off("new-order", handleUpdate);
//     };
//   }, [socket, refreshLoadedOrders]);

//   const handleUpdateClick = (order) => {
//     try {
//       const orderId = order._id || order.id;
//       const shortId = orderId?.toString().slice(-8).toUpperCase();

//       const confirmed = window.confirm(
//         `Items from Order #${shortId} will be loaded into your cart.\n\n` +
//           `You can add or remove items in the cart and click "Update Order" to apply the changes.\n\n` +
//           `Do you want to continue?`,
//       );

//       if (!confirmed) return;

//       dispatch(clearCart());

//       const targetRestaurantId = restaurantInfo?._id || restaurantId;
//       dispatch(setRestaurant(targetRestaurantId));
//       dispatch(setUpdateOrderId(orderId));

//       if (order.appliedOffers && order.appliedOffers.length > 0) {
//         dispatch(
//           updateCartCalculation({
//             appliedOffers: order.appliedOffers,
//             promoDiscount:
//               order.orderSummary?.totalDiscount || order.totalDiscount || 0,
//             totalDiscount:
//               order.orderSummary?.totalDiscount || order.totalDiscount || 0,
//             finalTotal: order.orderSummary?.totalAmount || order.total || 0,
//             subtotal: order.orderSummary?.subtotal || order.subtotal || 0,
//             freeItems: order.freeItems || [],
//           }),
//         );
//       }

//       if (order.orderType) {
//         localStorage.setItem(
//           `selected_order_type_${targetRestaurantId}`,
//           order.orderType,
//         );
//       }

//       let loadedCount = 0;
//       (order.items || []).forEach((item) => {
//         const isFree =
//           item.isFree || item.price === 0 || item.itemName?.includes("FREE");
//         if (isFree) return;

//         const itemId =
//           typeof item.itemId === "object"
//             ? item.itemId?._id
//             : item.itemId || item._id;
//         if (!itemId) return;

//         const cartItem = {
//           _id: itemId,
//           itemName: item.itemName?.replace(" (FREE)", "") || "Item",
//           price: item.originalPrice || item.price || 0,
//           originalPrice: item.originalPrice || item.price || 0,
//           discountedPrice: item.price || 0,
//           basePrice: item.originalPrice || item.price || 0,
//           qty: 1,
//           quantity: 1,
//           isVeg: item.isVeg ?? true,
//           image:
//             item.image ||
//             (typeof item.itemId === "object" ? item.itemId?.image : "") ||
//             "",
//           selectedSize: item.selectedSize || null,
//           selectedVariant: item.selectedVariant || null,
//           selectedAddons: item.selectedAddons || [],
//           appliedOffer: item.appliedOffer || null,
//           isFree: false,
//         };

//         const qty = item.quantity || item.qty || 1;
//         for (let i = 0; i < qty; i++) {
//           dispatch(addItem(cartItem));
//           loadedCount++;
//         }
//       });

//       if (loadedCount === 0) {
//         setSnack({
//           open: true,
//           msg: "No items could be loaded into the cart.",
//           type: "warning",
//         });
//         dispatch(setUpdateOrderId(null));
//         return;
//       }

//       setSnack({
//         open: true,
//         msg: `${loadedCount} ${loadedCount === 1 ? "item" : "items"} successfully loaded into cart!`,
//         type: "success",
//       });

//       const urlIdentifier = restaurantInfo?.slug || restaurantId;
//       setTimeout(() => {
//         navigate(`/restaurant/${urlIdentifier}/menu?openCart=true`);
//       }, 500);
//     } catch (err) {
//       console.error("Update click failed:", err);
//       setSnack({
//         open: true,
//         msg: "Cart load failed",
//         type: "error",
//       });
//     }
//   };

//   // PDF INVOICE DOWNLOAD
//   const handleDownloadInvoice = (order) => {
//     try {
//       const doc = new jsPDF("p", "mm", "a4");
//       const pageWidth = doc.internal.pageSize.getWidth();
//       const pageHeight = doc.internal.pageSize.getHeight();

//       const orderId = order._id || order.id;
//       const shortId = orderId?.toString().slice(-8).toUpperCase();

//       const restObj =
//         typeof order.restaurant === "object" ? order.restaurant : {};
//       const restaurantName =
//         restObj.restaurantName ||
//         restaurantInfo?.restaurantName ||
//         "Restaurant";
//       const restaurantAddress =
//         restaurantInfo?.restaurantAddress ||
//         restaurantInfo?.address ||
//         restObj.restaurantAddress ||
//         restObj.address ||
//         "";
//       const restaurantPhone =
//         restaurantInfo?.mobile ||
//         restaurantInfo?.whatsappNumber ||
//         restObj.mobile ||
//         restObj.whatsappNumber ||
//         "";
//       const restaurantCity = restaurantInfo?.city || restObj.city || "";
//       const restaurantState = restaurantInfo?.state || restObj.state || "";

//       const orderDate = order.createdAt
//         ? new Date(order.createdAt).toLocaleString("en-IN", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//             hour: "2-digit",
//             minute: "2-digit",
//           })
//         : "N/A";

//       const orderTypeLabel =
//         {
//           DINE_IN: "Dine In",
//           DELIVERY: "Delivery",
//           TAKEAWAY: "Takeaway",
//         }[order.orderType] || order.orderType;

//       // HEADER
//       doc.setFillColor(30, 70, 32);
//       doc.rect(0, 0, pageWidth, 36, "F");

//       doc.setTextColor(255, 255, 255);
//       doc.setFontSize(20);
//       doc.setFont("helvetica", "bold");
//       doc.text(restaurantName.toUpperCase(), 14, 15);

//       doc.setFontSize(8.5);
//       doc.setFont("helvetica", "normal");
//       let restLoc = [restaurantAddress, restaurantCity, restaurantState]
//         .filter(Boolean)
//         .join(", ");
//       if (restLoc) {
//         doc.text(doc.splitTextToSize(restLoc, 110), 14, 21);
//       }
//       if (restaurantPhone) {
//         doc.text(`Contact: +91 ${restaurantPhone}`, 14, 30);
//       }

//       doc.setFontSize(16);
//       doc.setFont("helvetica", "bold");
//       doc.text("TAX INVOICE", pageWidth - 14, 15, { align: "right" });

//       doc.setFontSize(8.5);
//       doc.setFont("helvetica", "normal");
//       doc.text(`Invoice No: #${shortId}`, pageWidth - 14, 22, {
//         align: "right",
//       });
//       doc.text(`Date: ${orderDate}`, pageWidth - 14, 27, { align: "right" });
//       doc.text(`Status: ${order.status || "PENDING"}`, pageWidth - 14, 32, {
//         align: "right",
//       });

//       // CUSTOMER & ORDER BOX
//       let yPos = 44;

//       doc.setFillColor(248, 250, 252);
//       doc.setDrawColor(226, 232, 240);
//       doc.roundedRect(14, yPos, pageWidth - 28, 28, 2, 2, "FD");

//       doc.setTextColor(30, 41, 59);
//       doc.setFontSize(9);
//       doc.setFont("helvetica", "bold");
//       doc.text("CUSTOMER DETAILS:", 18, yPos + 6);

//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(8.5);
//       doc.text(
//         `Name: ${order.customer?.name || "Guest Customer"}`,
//         18,
//         yPos + 12,
//       );
//       doc.text(`Phone: ${order.customer?.phone || "N/A"}`, 18, yPos + 17);
//       if (order.customer?.address && order.orderType === "DELIVERY") {
//         const addressLines = doc.splitTextToSize(
//           `Address: ${order.customer.address}`,
//           85,
//         );
//         doc.text(addressLines, 18, yPos + 22);
//       }

//       const rightColX = pageWidth / 2 + 10;
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(9);
//       doc.text("ORDER INFORMATION:", rightColX, yPos + 6);

//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(8.5);
//       doc.text(`Order Type: ${orderTypeLabel}`, rightColX, yPos + 12);
//       doc.text(
//         `Table Number: ${order.tableNumber || "N/A"}`,
//         rightColX,
//         yPos + 17,
//       );
//       doc.text(
//         `Payment Method: ${order.paymentMethod || "CASH"}`,
//         rightColX,
//         yPos + 22,
//       );

//       // ITEMS TABLE
//       const tableStartY = yPos + 34;

//       const regularItems = (order.items || []).filter((item) => {
//         const isFree =
//           item.isFree === true ||
//           item.price === 0 ||
//           item.itemName?.toLowerCase().includes("(free)") ||
//           item.appliedOffer?.isFree === true ||
//           item.appliedOffer?.offerCategory === "FREE_ITEM";
//         return !isFree;
//       });

//       const itemsBody = regularItems.map((item, idx) => {
//         const qty = Number(item.quantity || item.qty || 1);
//         const originalPrice = Number(item.originalPrice || item.price || 0);
//         const finalPrice = Number(item.price || 0);
//         const discountAmount = Math.max(0, originalPrice - finalPrice);
//         const total = Number(item.total || finalPrice * qty);

//         let itemDesc = item.itemName || "Item";
//         const meta = [
//           item.selectedSize?.name && `Size: ${item.selectedSize.name}`,
//           item.selectedVariant?.name && `Var: ${item.selectedVariant.name}`,
//           item.selectedAddons?.length > 0 &&
//             `Addons: ${item.selectedAddons.map((a) => a.name).join(", ")}`,
//         ]
//           .filter(Boolean)
//           .join(" | ");

//         if (meta) {
//           itemDesc += `\n(${meta})`;
//         }

//         return [
//           idx + 1,
//           itemDesc,
//           qty,
//           `Rs. ${originalPrice.toFixed(2)}`,
//           discountAmount > 0 ? `-Rs. ${discountAmount.toFixed(2)}` : "—",
//           `Rs. ${finalPrice.toFixed(2)}`,
//           `Rs. ${total.toFixed(2)}`,
//         ];
//       });

//       const freeItemsMap = new Map();

//       (order.freeItems || []).forEach((fi) => {
//         const key = fi.itemName.replace(/\(FREE.*?\)/gi, "").trim();
//         freeItemsMap.set(key, {
//           name: key,
//           quantity: fi.quantity || 1,
//           price: Number(fi.price || fi.originalPrice || 0),
//         });
//       });

//       (order.items || []).forEach((item) => {
//         const isFree =
//           item.isFree === true ||
//           item.price === 0 ||
//           item.itemName?.toLowerCase().includes("(free)") ||
//           item.appliedOffer?.isFree === true;

//         if (isFree) {
//           const key = item.itemName.replace(/\(FREE.*?\)/gi, "").trim();
//           if (!freeItemsMap.has(key)) {
//             freeItemsMap.set(key, {
//               name: key,
//               quantity: item.quantity || 1,
//               price: Number(item.originalPrice || item.price || 0),
//             });
//           }
//         }
//       });

//       let currentIndex = regularItems.length;
//       freeItemsMap.forEach((fi) => {
//         currentIndex++;
//         itemsBody.push([
//           currentIndex,
//           `${fi.name} [FREE OFFER]`,
//           fi.quantity,
//           `Rs. ${fi.price.toFixed(2)}`,
//           "FREE",
//           "Rs. 0.00",
//           "Rs. 0.00",
//         ]);
//       });

//       autoTable(doc, {
//         startY: tableStartY,
//         head: [
//           [
//             "#",
//             "Item Description",
//             "Qty",
//             "Price",
//             "Discount",
//             "Net Rate",
//             "Total",
//           ],
//         ],
//         body: itemsBody,
//         theme: "striped",
//         headStyles: {
//           fillColor: [46, 125, 50],
//           textColor: [255, 255, 255],
//           fontSize: 8.5,
//           fontStyle: "bold",
//           halign: "center",
//         },
//         bodyStyles: {
//           fontSize: 8,
//           textColor: [33, 37, 41],
//           cellPadding: 2.5,
//         },
//         columnStyles: {
//           0: { halign: "center", cellWidth: 10 },
//           1: { cellWidth: "auto" },
//           2: { halign: "center", cellWidth: 12 },
//           3: { halign: "right", cellWidth: 22 },
//           4: { halign: "right", cellWidth: 22, textColor: [46, 125, 50] },
//           5: { halign: "right", cellWidth: 22 },
//           6: { halign: "right", cellWidth: 25, fontStyle: "bold" },
//         },
//         alternateRowStyles: {
//           fillColor: [248, 249, 250],
//         },
//         margin: { left: 14, right: 14 },
//       });

//       let finalY = doc.lastAutoTable.finalY + 6;

//       const subtotal = Number(
//         order.orderSummary?.subtotal ?? order.subtotal ?? 0,
//       );
//       const totalDiscount = Number(
//         order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0,
//       );
//       const deliveryCharge = Number(
//         order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
//       );
//       const totalAmount = Number(
//         order.orderSummary?.totalAmount ?? order.total ?? 0,
//       );
//       const paidAmount = Number(
//         order.orderSummary?.paidAmount ||
//           (order.paymentStatus === "PAID" ? totalAmount : 0) ||
//           0,
//       );
//       const balanceAmount = Number(order.orderSummary?.balanceAmount ?? 0);
//       const refundDue = Number(order.orderSummary?.refundDue ?? 0);

//       const hasOffers = order.appliedOffers && order.appliedOffers.length > 0;
//       if (hasOffers) {
//         doc.setFillColor(240, 253, 244);
//         doc.setDrawColor(187, 247, 208);
//         doc.roundedRect(14, finalY, 85, 28, 2, 2, "FD");

//         doc.setFontSize(8.5);
//         doc.setFont("helvetica", "bold");
//         doc.setTextColor(22, 101, 52);
//         doc.text("APPLIED OFFERS / DISCOUNTS:", 18, finalY + 5);

//         doc.setFont("helvetica", "normal");
//         doc.setFontSize(7.5);
//         let offerY = finalY + 10;
//         order.appliedOffers.slice(0, 3).forEach((off) => {
//           doc.text(
//             `• ${off.offerCode}: Save Rs. ${Number(
//               off.discountAmount || 0,
//             ).toFixed(2)}`,
//             18,
//             offerY,
//           );
//           offerY += 4;
//         });
//       }

//       const summaryX = pageWidth - 90;
//       let summaryY = finalY + 2;

//       doc.setFontSize(8.5);
//       doc.setFont("helvetica", "normal");
//       doc.setTextColor(71, 85, 105);

//       doc.text("Subtotal:", summaryX, summaryY);
//       doc.text(`Rs. ${subtotal.toFixed(2)}`, pageWidth - 14, summaryY, {
//         align: "right",
//       });
//       summaryY += 5;

//       if (totalDiscount > 0) {
//         doc.setTextColor(46, 125, 50);
//         doc.text("Total Discounts:", summaryX, summaryY);
//         doc.text(`-Rs. ${totalDiscount.toFixed(2)}`, pageWidth - 14, summaryY, {
//           align: "right",
//         });
//         summaryY += 5;
//       }

//       if (order.orderType === "DELIVERY") {
//         doc.setTextColor(71, 85, 105);
//         doc.text("Delivery Charge:", summaryX, summaryY);
//         doc.text(
//           deliveryCharge === 0 ? "FREE" : `Rs. ${deliveryCharge.toFixed(2)}`,
//           pageWidth - 14,
//           summaryY,
//           { align: "right" },
//         );
//         summaryY += 5;
//       }

//       doc.setDrawColor(203, 213, 225);
//       doc.line(summaryX, summaryY, pageWidth - 14, summaryY);
//       summaryY += 5;

//       doc.setFontSize(11);
//       doc.setFont("helvetica", "bold");
//       doc.setTextColor(15, 23, 42);
//       doc.text("Final Total:", summaryX, summaryY);
//       doc.setTextColor(46, 125, 50);
//       doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
//         align: "right",
//       });
//       summaryY += 6;

//       doc.setFontSize(8.5);
//       doc.setFont("helvetica", "normal");
//       doc.setTextColor(71, 85, 105);
//       if (paidAmount > 0) {
//         doc.text("Amount Paid:", summaryX, summaryY);
//         doc.text(`Rs. ${paidAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
//           align: "right",
//         });
//         summaryY += 5;
//       }

//       if (balanceAmount > 0) {
//         doc.setFont("helvetica", "bold");
//         doc.setTextColor(230, 81, 0);
//         doc.text("Remaining Balance:", summaryX, summaryY);
//         doc.text(`Rs. ${balanceAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
//           align: "right",
//         });
//         summaryY += 5;
//       }

//       if (refundDue > 0) {
//         const boxHeight = 16;
//         const boxY = summaryY - 0;

//         doc.setFillColor(255, 248, 240);
//         doc.setDrawColor(230, 81, 0);
//         doc.roundedRect(14, boxY, pageWidth - 28, boxHeight, 2, 2, "FD");

//         doc.setFontSize(9);
//         doc.setFont("helvetica", "bold");
//         doc.setTextColor(230, 81, 0);
//         doc.text("REFUND DUE FROM RESTAURANT", 18, boxY + 6);

//         doc.setFontSize(11);
//         doc.text(`Rs. ${refundDue.toFixed(2)}`, pageWidth - 18, boxY + 6, {
//           align: "right",
//         });

//         doc.setFontSize(7.5);
//         doc.setFont("helvetica", "italic");
//         doc.setTextColor(120, 80, 40);
//         doc.text(
//           "Restaurant will settle this amount via direct UPI or Cash refund",
//           18,
//           boxY + 12,
//         );

//         summaryY = boxY + boxHeight + 6;
//       }

//       const footerY = pageHeight - 16;
//       doc.setDrawColor(226, 232, 240);
//       doc.line(14, footerY - 4, pageWidth - 14, footerY - 4);

//       doc.setFontSize(7.5);
//       doc.setFont("helvetica", "italic");
//       doc.setTextColor(148, 163, 184);
//       doc.text(
//         "Thank you for dining with us! Powered by RestaurantWala",
//         pageWidth / 2,
//         footerY,
//         { align: "center" },
//       );
//       doc.setFontSize(6.5);
//       doc.text(
//         `Computer generated receipt • Generated on ${new Date().toLocaleString(
//           "en-IN",
//         )}`,
//         pageWidth / 2,
//         footerY + 4,
//         { align: "center" },
//       );

//       doc.save(`Invoice_${restaurantName.replace(/\s+/g, "_")}_${shortId}.pdf`);

//       setSnack({
//         open: true,
//         msg: "Invoice downloaded successfully! 📄",
//         type: "success",
//       });
//     } catch (err) {
//       console.error("PDF generation failed:", err);
//       setSnack({
//         open: true,
//         msg: "Failed to download invoice",
//         type: "error",
//       });
//     }
//   };

//   if (loading && filteredOrders.length === 0) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "60vh",
//         }}
//       >
//         <CircularProgress sx={{ color: "var(--primary, #FF6B00)" }} />
//       </Box>
//     );
//   }

//   const isEmpty = filteredOrders.length === 0;

//   return (
//     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 6 }}>
//       <Box sx={{ px: { xs: 1.5, sm: 2 }, pt: 2 }}>
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "end",
//             alignItems: "center",
//             mb: 1.5,
//           }}
//         >
//           <Button
//             size="small"
//             variant="text"
//             onClick={() =>
//               getMyOrders({ page: 1, limit: PAGE_SIZE, append: false })
//             }
//             startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
//             sx={{
//               textTransform: "none",
//               color: "var(--primary, #FF6B00)",
//               fontWeight: 700,
//               fontSize: "0.75rem",
//             }}
//           >
//             Refresh
//           </Button>
//         </Box>

//         {/* Empty state */}
//         {isEmpty && !loading && (
//           <Box sx={{ textAlign: "center", py: 8 }}>
//             <Box
//               sx={{
//                 width: 72,
//                 height: 72,
//                 borderRadius: "50%",
//                 bgcolor: "#fff3e0",
//                 mx: "auto",
//                 mb: 2,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <ReceiptLongIcon
//                 sx={{ fontSize: 36, color: "var(--primary, #FF6B00)" }}
//               />
//             </Box>
//             <Typography
//               variant="subtitle1"
//               sx={{ fontWeight: 700, color: "#333", mb: 0.5 }}
//             >
//               No orders yet
//             </Typography>
//             <Typography
//               variant="caption"
//               sx={{ color: "#888", display: "block", mb: 2 }}
//             >
//               Place your first order from the menu!
//             </Typography>
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={() => {
//                 const targetId = restaurantInfo?.slug || restaurantId;
//                 navigate(`/restaurant/${targetId}/menu`);
//               }}
//               sx={{
//                 borderColor: "var(--primary, #FF6B00)",
//                 color: "var(--primary, #FF6B00)",
//                 borderRadius: 2,
//                 textTransform: "none",
//                 fontWeight: 600,
//               }}
//             >
//               Browse Menu
//             </Button>
//           </Box>
//         )}

//         {/* Orders list */}
//         {filteredOrders.map((order, index) => {
//           const isPending = order.status === "PENDING";
//           const orderId = order._id || order.id;
//           const shortId = orderId?.toString().slice(-8).toUpperCase();
//           const freeItemsValue =
//             order.freeItems?.reduce(
//               (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
//               0,
//             ) || 0;
//           const subtotal = order.orderSummary?.subtotal ?? order.subtotal ?? 0;
//           const totalDiscount =
//             order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0;
//           const deliveryCharge = Number(
//             order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
//           );
//           const total = Number(order.orderSummary?.totalAmount ?? order.total ?? 0);

//           // ⭐ Paid Amount, Balance Amount, and Refund Due extraction
//           const paidAmount = Number(
//             order.orderSummary?.paidAmount ||
//               (order.paymentStatus === "PAID" ? total : 0) ||
//               0,
//           );
//           const balanceAmount = Number(
//             order.orderSummary?.balanceAmount ??
//               (total > paidAmount ? total - paidAmount : 0),
//           );
//           const refundDue = Number(
//             order.orderSummary?.refundDue ??
//               (paidAmount > total && total > 0 ? paidAmount - total : 0),
//           );

//           return (
//             <Paper
//               key={orderId || index}
//               elevation={0}
//               sx={{
//                 borderRadius: 3,
//                 bgcolor: "white",
//                 border: "1px solid #f0f0f0",
//                 mb: 1.5,
//                 overflow: "hidden",
//                 boxShadow:
//                   index === 0
//                     ? "0 2px 12px rgba(255,107,0,0.12)"
//                     : "0 1px 4px rgba(0,0,0,0.06)",
//               }}
//             >
//               {index === 0 && (
//                 <Box
//                   sx={{
//                     bgcolor: "rgba(255,107,0,0.08)",
//                     px: 2,
//                     py: 0.6,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.8,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 6,
//                       height: 6,
//                       borderRadius: "50%",
//                       bgcolor: "var(--primary, #FF6B00)",
//                       animation: "pulse 1.5s infinite",
//                     }}
//                   />
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: "var(--primary, #FF6B00)",
//                       fontWeight: 700,
//                       fontSize: "0.72rem",
//                     }}
//                   >
//                     Latest Order
//                   </Typography>
//                 </Box>
//               )}

//               <Box sx={{ p: 2 }}>
//                 {/* Header */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "flex-start",
//                     mb: 1.2,
//                   }}
//                 >
//                   <Box>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontWeight: 700,
//                         fontSize: "0.85rem",
//                         color: "#1a1a1a",
//                       }}
//                     >
//                       Order #{shortId}
//                     </Typography>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 0.5,
//                         mt: 0.3,
//                       }}
//                     >
//                       <AccessTimeIcon sx={{ fontSize: 12, color: "#aaa" }} />
//                       <Typography
//                         variant="caption"
//                         sx={{ color: "#aaa", fontSize: "0.7rem" }}
//                       >
//                         {order.createdAt
//                           ? new Date(order.createdAt).toLocaleString("en-IN", {
//                               day: "numeric",
//                               month: "short",
//                               hour: "2-digit",
//                               minute: "2-digit",
//                             })
//                           : "Recently"}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "flex-end",
//                       gap: 0.5,
//                     }}
//                   >
//                     <OrderTypeLabel type={order.orderType} />
//                     <StatusChip status={order.status} />
//                   </Box>
//                 </Box>

//                 <Divider sx={{ mb: 1.2 }} />

//                 <OrderItems
//                   items={order.items}
//                   freeItems={order.freeItems}
//                   freeItemsValue={freeItemsValue}
//                 />

//                 {/* Summary */}
//                 <Box sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #f0f0f0" }}>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       fontWeight: 700,
//                       color: "#333",
//                       mb: 1,
//                       display: "block",
//                       fontSize: "0.75rem",
//                       textTransform: "uppercase",
//                       letterSpacing: 0.5,
//                     }}
//                   >
//                     Order Summary
//                   </Typography>

//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       mb: 0.5,
//                     }}
//                   >
//                     <Typography
//                       variant="caption"
//                       sx={{ color: "#666", fontSize: "0.78rem" }}
//                     >
//                       Subtotal
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{ fontWeight: 600, fontSize: "0.78rem" }}
//                     >
//                       ₹{Number(subtotal).toFixed(2)}
//                     </Typography>
//                   </Box>

//                   {totalDiscount > 0 && (
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         mb: 0.5,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{ color: "#2e7d32", fontSize: "0.78rem" }}
//                       >
//                         Total discounts
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color: "#2e7d32",
//                           fontWeight: 700,
//                           fontSize: "0.78rem",
//                         }}
//                       >
//                         -₹{Number(totalDiscount).toFixed(2)}
//                       </Typography>
//                     </Box>
//                   )}

//                   {order.orderType === "DELIVERY" && (
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         mb: 0.5,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{ color: "#666", fontSize: "0.78rem" }}
//                       >
//                         Delivery Charge
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           fontWeight: 700,
//                           fontSize: "0.78rem",
//                           color: deliveryCharge === 0 ? "#2e7d32" : "#1a1a1a",
//                         }}
//                       >
//                         {deliveryCharge === 0
//                           ? "FREE"
//                           : `₹${deliveryCharge.toFixed(2)}`}
//                       </Typography>
//                     </Box>
//                   )}

//                   <Divider sx={{ my: 0.8 }} />

//                   <Box
//                     sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
//                   >
//                     <Typography
//                       variant="body2"
//                       sx={{ fontWeight: 700, fontSize: "0.85rem" }}
//                     >
//                       Total Amount
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontWeight: 800,
//                         color: "#2e7d32",
//                         fontSize: "0.9rem",
//                       }}
//                     >
//                       ₹{Number(total).toFixed(2)}
//                     </Typography>
//                   </Box>

//                   {/* ⭐ NEW: Already Paid Earlier Section */}
//                   {paidAmount > 0 && (
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         mb: 0.5,
//                         px: 1,
//                         py: 0.4,
//                         bgcolor: "#f0fdf4",
//                         borderRadius: 1.5,
//                         border: "1px dashed #86efac",
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{ color: "#166534", fontWeight: 700, fontSize: "0.75rem" }}
//                       >
//                         ✓ Already Paid Earlier:
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{ fontWeight: 800, color: "#166534", fontSize: "0.8rem" }}
//                       >
//                         ₹{paidAmount.toFixed(2)}
//                       </Typography>
//                     </Box>
//                   )}

//                   {/* ⭐ NEW: Remaining to Pay (Balance Amount) Section */}
//                   {balanceAmount > 0 && (
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         mb: 0.5,
//                         px: 1,
//                         py: 0.4,
//                         bgcolor: "#fff7ed",
//                         borderRadius: 1.5,
//                         border: "1px dashed #fdba74",
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{ color: "#c2410c", fontWeight: 800, fontSize: "0.78rem" }}
//                       >
//                         Remaining to Pay:
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 900, color: "#c2410c", fontSize: "0.85rem" }}
//                       >
//                         ₹{balanceAmount.toFixed(2)}
//                       </Typography>
//                     </Box>
//                   )}

//                   {/* Refund Due Section (Jab order modify/cancel hone par refund due ho) */}
//                   {refundDue > 0 && (
//                     <Box
//                       sx={{
//                         mt: 1.2,
//                         p: 1.2,
//                         bgcolor: "#fff3e0",
//                         borderRadius: 2,
//                         border: "1px dashed #e65100",
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             fontWeight: 800,
//                             color: "#e65100",
//                             display: "block",
//                           }}
//                         >
//                           ⏳ Refund Due from Restaurant:
//                         </Typography>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: "#666", fontSize: "0.68rem" }}
//                         >
//                           Items were reduced. The restaurant will settle ₹
//                           {refundDue.toFixed(2)} via direct UPI or Cash.
//                         </Typography>
//                       </Box>
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 900, color: "#e65100" }}
//                       >
//                         ₹{refundDue.toFixed(2)}
//                       </Typography>
//                     </Box>
//                   )}

//                   {order.paymentStatus === "REFUNDED" && (
//                     <Box
//                       sx={{
//                         mt: 1.2,
//                         p: 1,
//                         bgcolor: "#e8f5e9",
//                         borderRadius: 2,
//                         border: "1px solid #a5d6a7",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{ fontWeight: 700, color: "#2e7d32" }}
//                       >
//                         Refund Completed: Restaurant has settled your refund amount.
//                       </Typography>
//                     </Box>
//                   )}

//                   {totalDiscount > 0 && (
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         display: "block",
//                         textAlign: "right",
//                         color: "#2e7d32",
//                         mt: 0.5,
//                         fontSize: "0.7rem",
//                         fontWeight: 600,
//                       }}
//                     >
//                       🎉 You saved ₹{Number(totalDiscount).toFixed(2)}!
//                     </Typography>
//                   )}
//                 </Box>

//                 {/* Actions */}
//                 <Box
//                   sx={{ display: "flex", gap: 1, mt: 1.5, flexWrap: "wrap" }}
//                 >
//                   <Button
//                     size="small"
//                     variant="outlined"
//                     startIcon={<WhatsAppIcon sx={{ fontSize: 16 }} />}
//                     onClick={() => {
//                       const restaurantPhone =
//                         typeof order.restaurant === "object"
//                           ? order.restaurant?.whatsappNumber
//                           : restaurantInfo?.whatsappNumber;
//                       const fallbackPhone = "917734904014";
//                       const phone = restaurantPhone || fallbackPhone;
//                       const message = `Hi, I'd like to follow up on my order #${shortId}`;
//                       window.open(
//                         `https://wa.me/${phone}?text=${encodeURIComponent(
//                           message,
//                         )}`,
//                         "_blank",
//                       );
//                     }}
//                     sx={{
//                       borderColor: "#25D366",
//                       color: "#25D366",
//                       "&:hover": {
//                         bgcolor: "#f0fff4",
//                         borderColor: "#128C7E",
//                       },
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                       fontSize: "0.78rem",
//                       flex: 1,
//                       minWidth: 100,
//                     }}
//                   >
//                     WhatsApp
//                   </Button>

//                   <Button
//                     size="small"
//                     variant="outlined"
//                     startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
//                     onClick={() => handleDownloadInvoice(order)}
//                     sx={{
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                       fontSize: "0.78rem",
//                       flex: 1,
//                       minWidth: 100,
//                       borderColor: "#2e7d32",
//                       color: "#2e7d32",
//                       "&:hover": {
//                         bgcolor: "#e8f5e9",
//                         borderColor: "#1b5e20",
//                       },
//                     }}
//                   >
//                     Invoice
//                   </Button>

//                   {isPending && (
//                     <Button
//                       size="small"
//                       variant="outlined"
//                       color="primary"
//                       startIcon={<EditIcon sx={{ fontSize: 16 }} />}
//                       onClick={() => handleUpdateClick(order)}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         fontSize: "0.78rem",
//                         flex: 1,
//                         minWidth: 100,
//                       }}
//                     >
//                       Update
//                     </Button>
//                   )}

//                   {isPending && (
//                     <Button
//                       size="small"
//                       variant="outlined"
//                       color="error"
//                       startIcon={<CancelIcon sx={{ fontSize: 16 }} />}
//                       onClick={() => handleCancelClick(order)}
//                       sx={{
//                         borderRadius: 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         fontSize: "0.78rem",
//                         flex: 1,
//                         minWidth: 100,
//                       }}
//                     >
//                       Cancel
//                     </Button>
//                   )}
//                 </Box>
//               </Box>
//             </Paper>
//           );
//         })}

//         {/* Infinite scroll sentinel */}
//         {!isEmpty && (
//           <Box
//             ref={loadMoreRef}
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               py: 3,
//               minHeight: 60,
//             }}
//           >
//             {loadingMore && (
//               <CircularProgress
//                 size={28}
//                 sx={{ color: "var(--primary, #FF6B00)" }}
//               />
//             )}
//             {!hasMore && filteredOrders.length > 0 && (
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: "#aaa",
//                   fontSize: "0.72rem",
//                   fontWeight: 600,
//                   letterSpacing: 0.4,
//                 }}
//               >
//                 {/* — End of orders — */}
//               </Typography>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* Cancel Dialog */}
//       <Dialog
//         open={cancelDialog.open}
//         onClose={() => setCancelDialog({ open: false, order: null })}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{ fontWeight: 700, color: "#c62828" }}>
//           Cancel Order?
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" sx={{ mb: 2 }}>
//             Are you sure you want to cancel order #
//             {(cancelDialog.order?._id || cancelDialog.order?.id)
//               ?.toString()
//               .slice(-8)
//               .toUpperCase()}
//             ?
//           </Typography>
//           <TextField
//             fullWidth
//             size="small"
//             label="Reason (optional)"
//             value={cancelReason}
//             onChange={(e) => setCancelReason(e.target.value)}
//             multiline
//             rows={2}
//             placeholder="e.g. Changed my mind"
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setCancelDialog({ open: false, order: null })}>
//             No, Keep it
//           </Button>
//           <Button
//             onClick={handleCancelConfirm}
//             color="error"
//             variant="contained"
//           >
//             Yes, Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snack.open}
//         autoHideDuration={3000}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         sx={{ bottom: 70 }}
//       >
//         <Alert severity={snack.type} variant="filled" sx={{ borderRadius: 2 }}>
//           {snack.msg}
//         </Alert>
//       </Snackbar>

//       <style>
//         {`
//           @keyframes pulse {
//             0%, 100% { opacity: 1; transform: scale(1); }
//             50% { opacity: 0.5; transform: scale(1.2); }
//           }
//         `}
//       </style>
//     </Box>
//   );
// };

// export default OrdersPage;

import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import {
  Box,
  Typography,
  Paper,
  Chip,
  Button,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Snackbar,
  Alert,
  Tooltip,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import RefreshIcon from "@mui/icons-material/Refresh";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import DownloadIcon from "@mui/icons-material/Download";
import { useMyOrders } from "../../../hooks/useMyOrders";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addItem,
  clearCart,
  setRestaurant,
  selectCartRestaurant,
  setUpdateOrderId,
} from "../../../redux/slices/cartSlice";
import { updateCartCalculation } from "../../../redux/slices/publicSlice";
import { useSocket } from "../../../context/SocketContext";
import { setupPushNotifications } from "../../../utils/pushNotifications";
import axiosInstance from "../../../utils/axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const PAGE_SIZE = 8;

// ========== OrderType Components ==========
const OrderTypeIcon = ({ type }) => {
  const icons = {
    DINE_IN: <RestaurantIcon sx={{ fontSize: 16, color: "#2e7d32", ml: 1 }} />,
    DELIVERY: (
      <LocalShippingIcon sx={{ fontSize: 16, color: "#1976d2", ml: 1 }} />
    ),
    TAKEAWAY: (
      <TakeoutDiningIcon sx={{ fontSize: 16, color: "#e65100", ml: 1 }} />
    ),
  };
  return icons[type] || icons.DINE_IN;
};

const OrderTypeLabel = ({ type }) => {
  const labels = {
    DINE_IN: "Dine In",
    DELIVERY: "Delivery",
    TAKEAWAY: "Takeaway",
  };
  const colors = {
    DINE_IN: "#2e7d32",
    DELIVERY: "#1976d2",
    TAKEAWAY: "#e65100",
  };
  return (
    <Chip
      label={labels[type] || type}
      size="small"
      icon={<OrderTypeIcon type={type} />}
      sx={{
        height: 22,
        fontSize: "0.65rem",
        fontWeight: 600,
        bgcolor: `${colors[type] || "#2e7d32"}15`,
        color: colors[type] || "#2e7d32",
        border: `1px solid ${colors[type] || "#2e7d32"}40`,
        "& .MuiChip-icon": { fontSize: 14 },
      }}
    />
  );
};

// Status Chip
const StatusChip = ({ status }) => {
  const colors = {
    PENDING: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
    ACCEPTED: { bg: "#e3f2fd", color: "#1565c0", border: "#64b5f6" },
    PREPARING: { bg: "#f3e5f5", color: "#6a1b9a", border: "#ba68c8" },
    OUT_FOR_DELIVERY: { bg: "#fff8e1", color: "#f57f17", border: "#ffd54f" },
    COMPLETED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
    DELIVERED: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
    CANCELLED: { bg: "#ffebee", color: "#c62828", border: "#ef9a9a" },
  };
  const c = colors[status] || colors.PENDING;
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        height: 20,
        fontSize: "0.62rem",
        fontWeight: 700,
        bgcolor: c.bg,
        color: c.color,
        border: `1px solid ${c.border}`,
      }}
    />
  );
};

// ========== OrderItems ==========
const OrderItems = ({ items, freeItems }) => {
  const [expanded, setExpanded] = useState(false);
  const initialDisplay = 3;
  const hasMoreItems = items?.length > initialDisplay;
  const displayItems = expanded ? items : items?.slice(0, initialDisplay) || [];

  return (
    <Box>
      <Box sx={{ mb: 1.2 }}>
        {items && items.length > 0 ? (
          <>
            {displayItems.map((item, i) => {
              const isFree =
                item.isFree ||
                item.price === 0 ||
                item.itemName?.includes("FREE");
              return (
                <Box key={i}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      mb: 0.4,
                      opacity: isFree ? 0.8 : 1,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: isFree ? "#888" : "#555",
                          fontSize: "0.78rem",
                          textDecoration: isFree ? "line-through" : "none",
                        }}
                      >
                        {item.itemName} × {item.quantity}
                        {isFree && (
                          <Chip
                            label="FREE"
                            size="small"
                            sx={{
                              ml: 1,
                              height: 16,
                              fontSize: "0.5rem",
                              bgcolor: "#e8f5e9",
                              color: "#2e7d32",
                              fontWeight: 700,
                            }}
                          />
                        )}
                      </Typography>
                      {item.appliedOffer && !isFree && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#2e7d32",
                            fontSize: "0.65rem",
                            display: "block",
                            mt: 0.2,
                          }}
                        >
                          🏷 {item.appliedOffer.offerCode} Saved ₹
                          {(
                            (item.originalPrice - item.price) *
                            item.quantity
                          ).toFixed(0)}
                        </Typography>
                      )}
                      {(item.selectedSize ||
                        item.selectedVariant ||
                        item.selectedAddons?.length > 0) && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#999",
                            fontSize: "0.6rem",
                            display: "block",
                            mt: 0.1,
                          }}
                        >
                          {[
                            item.selectedSize?.name &&
                              `Size: ${item.selectedSize.name}`,
                            item.selectedVariant?.name &&
                              `Variant: ${item.selectedVariant.name}`,
                            item.selectedAddons?.length > 0 &&
                              `Addons: ${item.selectedAddons
                                .map((a) => a.name)
                                .join(", ")}`,
                          ]
                            .filter(Boolean)
                            .join(" · ")}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      {isFree ? (
                        <Chip
                          label="FREE"
                          size="small"
                          sx={{
                            height: 16,
                            fontSize: "0.55rem",
                            bgcolor: "#e8f5e9",
                            color: "#2e7d32",
                            fontWeight: 700,
                          }}
                        />
                      ) : item.appliedOffer ? (
                        <>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#999",
                              textDecoration: "line-through",
                              fontSize: "0.7rem",
                              display: "block",
                            }}
                          >
                            ₹{(item.originalPrice * item.quantity).toFixed(0)}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#2e7d32",
                              fontWeight: 600,
                              fontSize: "0.78rem",
                            }}
                          >
                            ₹{(item.price * item.quantity).toFixed(0)}
                          </Typography>
                        </>
                      ) : (
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#333",
                            fontWeight: 600,
                            fontSize: "0.78rem",
                          }}
                        >
                          ₹{(item.price * item.quantity).toFixed(0)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              );
            })}

            {hasMoreItems && (
              <Button
                size="small"
                onClick={() => setExpanded(!expanded)}
                endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{
                  mt: 0.5,
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  color: "#2e7d32",
                  textTransform: "none",
                  "&:hover": { bgcolor: "#e8f5e9" },
                }}
              >
                {expanded
                  ? `Show Less (${items.length} items)`
                  : `Show ${items.length - initialDisplay} more item${
                      items.length - initialDisplay !== 1 ? "s" : ""
                    }`}
              </Button>
            )}
          </>
        ) : (
          <Typography
            variant="caption"
            sx={{ color: "#999", fontStyle: "italic" }}
          >
            No items to display
          </Typography>
        )}
      </Box>

      {freeItems && freeItems.length > 0 && (
        <Box
          sx={{
            mb: 1,
            bgcolor: "#e8f5e9",
            p: 1,
            borderRadius: 1,
            border: "1px solid #c8e6c9",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#2e7d32",
              fontWeight: 700,
              fontSize: "0.75rem",
              display: "block",
              mb: 0.5,
            }}
          >
            🎁 Free Items from Offers
          </Typography>
          {freeItems.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 0.3,
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: "#555", fontSize: "0.78rem" }}
              >
                {item.itemName} × {item.quantity}
              </Typography>
              <Chip
                label={`FREE (₹${(item.price * item.quantity).toFixed(
                  0,
                )} saved)`}
                size="small"
                sx={{
                  height: 18,
                  fontSize: "0.55rem",
                  bgcolor: "#2e7d32",
                  color: "white",
                }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

// ========== MAIN OrdersPage ==========
const OrdersPage = ({ restaurantId, restaurantInfo }) => {
  const {
    orders = [],
    loading,
    loadingMore,
    hasMore,
    currentPage,
    error,
    getMyOrders,
    updateMyOrder,
    cancelMyOrder,
    clearError,
  } = useMyOrders();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket } = useSocket();
  const cartRestaurant = useSelector(selectCartRestaurant);

  const [snack, setSnack] = useState({ open: false, msg: "", type: "success" });
  const [cancelDialog, setCancelDialog] = useState({
    open: false,
    order: null,
  });
  const [cancelReason, setCancelReason] = useState("");
  const [copiedKey, setCopiedKey] = useState("");

  // Restaurant Payment Settings (UPI & PhonePe)
  const [paymentSettings, setPaymentSettings] = useState({
    upiId: "",
    phonePeNumber: "",
  });

  const loadMoreRef = useRef(null);

  const refreshLoadedOrders = useCallback(() => {
    const safePage = currentPage || 1;
    const limit = Math.max(PAGE_SIZE, safePage * PAGE_SIZE);
    getMyOrders({ page: 1, limit, append: false });
  }, [getMyOrders, currentPage]);

  // Load orders & payment settings on mount
  useEffect(() => {
    getMyOrders({ page: 1, limit: PAGE_SIZE, append: false });

    // Restaurant ki payment settings fetch karein (UPI ID / PhonePe Number)
    const fetchPaymentSettings = async () => {
      const targetId =
        restaurantInfo?._id ||
        restaurantInfo?.slug ||
        restaurantId;
      if (!targetId) return;
      try {
        const res = await axiosInstance.get(`/api/payment/settings/${targetId}`);
        if (res.data?.success && res.data?.data) {
          setPaymentSettings({
            upiId: res.data.data.upiId || "",
            phonePeNumber: res.data.data.phonePeNumber || "",
          });
        }
      } catch (e) {
        console.error("Payment settings fetch error:", e);
      }
    };

    fetchPaymentSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantId, restaurantInfo]);

  useEffect(() => {
    if (restaurantId) {
      setupPushNotifications(restaurantId);
    }
  }, [restaurantId]);

  useEffect(() => {
    if (!socket) return;
    const handleUpdate = () => refreshLoadedOrders();
    socket.on("order-status-updated", handleUpdate);
    socket.on("new-order", handleUpdate);
    return () => {
      socket.off("order-status-updated", handleUpdate);
      socket.off("new-order", handleUpdate);
    };
  }, [socket, refreshLoadedOrders]);

  useEffect(() => {
    if (error) {
      setSnack({ open: true, msg: error, type: "error" });
      clearError();
    }
  }, [error, clearError]);

  const filteredOrders = useMemo(() => {
    if (!orders || orders.length === 0) return [];

    const currentSlug =
      restaurantInfo?.slug ||
      (restaurantId?.length !== 24 ? restaurantId : null);
    const currentObjectId =
      restaurantInfo?._id?.toString() ||
      (restaurantId?.length === 24 ? restaurantId : null);

    return orders.filter((o) => {
      const rest = o.restaurant || {};
      const restId = (rest._id || rest.id || rest).toString();
      const restSlug = rest.slug;

      if (currentSlug && restSlug && restSlug === currentSlug) return true;
      if (currentSlug && restId === currentSlug) return true;
      if (currentObjectId && restId === currentObjectId) return true;
      if (restId === restaurantId || restSlug === restaurantId) return true;

      return false;
    });
  }, [orders, restaurantId, restaurantInfo]);

  useEffect(() => {
    if (!hasMore || loading || loadingMore) return;
    const node = loadMoreRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          getMyOrders({
            page: (currentPage || 1) + 1,
            limit: PAGE_SIZE,
            append: true,
          });
        }
      },
      { rootMargin: "200px 0px" },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, loading, loadingMore, currentPage, getMyOrders]);

  // Copy handler with feedback
  const handleCopy = (text, key) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedKey(key);
    setSnack({
      open: true,
      msg: `Copied "${text}" to clipboard!`,
      type: "success",
    });
    setTimeout(() => {
      setCopiedKey("");
    }, 2000);
  };

  const handleCancelClick = (order) => {
    setCancelDialog({ open: true, order });
    setCancelReason("");
  };

  const handleCancelConfirm = async () => {
    try {
      await cancelMyOrder(
        cancelDialog.order._id || cancelDialog.order.id,
        cancelReason,
      );
      setSnack({
        open: true,
        msg: "Order cancelled successfully",
        type: "success",
      });
      refreshLoadedOrders();
    } catch (err) {
      setSnack({
        open: true,
        msg: err?.message || "Cancel failed",
        type: "error",
      });
    } finally {
      setCancelDialog({ open: false, order: null });
      setCancelReason("");
    }
  };

  const handleUpdateClick = (order) => {
    try {
      const orderId = order._id || order.id;
      const shortId = orderId?.toString().slice(-8).toUpperCase();

      const confirmed = window.confirm(
        `Items from Order #${shortId} will be loaded into your cart.\n\n` +
          `You can add or remove items in the cart and click "Update Order" to apply the changes.\n\n` +
          `Do you want to continue?`,
      );

      if (!confirmed) return;

      dispatch(clearCart());

      const targetRestaurantId = restaurantInfo?._id || restaurantId;
      dispatch(setRestaurant(targetRestaurantId));
      dispatch(setUpdateOrderId(orderId));

      if (order.appliedOffers && order.appliedOffers.length > 0) {
        dispatch(
          updateCartCalculation({
            appliedOffers: order.appliedOffers,
            promoDiscount:
              order.orderSummary?.totalDiscount || order.totalDiscount || 0,
            totalDiscount:
              order.orderSummary?.totalDiscount || order.totalDiscount || 0,
            finalTotal: order.orderSummary?.totalAmount || order.total || 0,
            subtotal: order.orderSummary?.subtotal || order.subtotal || 0,
            freeItems: order.freeItems || [],
          }),
        );
      }

      if (order.orderType) {
        localStorage.setItem(
          `selected_order_type_${targetRestaurantId}`,
          order.orderType,
        );
      }

      // let loadedCount = 0;
      // (order.items || []).forEach((item) => {
      //   const isFree =
      //     item.isFree || item.price === 0 || item.itemName?.includes("FREE");
      //   if (isFree) return;

      //   const itemId =
      //     typeof item.itemId === "object"
      //       ? item.itemId?._id
      //       : item.itemId || item._id;
      //   if (!itemId) return;

      //   const cartItem = {
      //     _id: itemId,
      //     itemName: item.itemName?.replace(" (FREE)", "") || "Item",
      //     price: item.originalPrice || item.price || 0,
      //     originalPrice: item.originalPrice || item.price || 0,
      //     discountedPrice: item.price || 0,
      //     basePrice: item.originalPrice || item.price || 0,
      //     qty: 1,
      //     quantity: 1,
      //     isVeg: item.isVeg ?? true,
      //     image:
      //       item.image ||
      //       (typeof item.itemId === "object" ? item.itemId?.image : "") ||
      //       "",
      //     selectedSize: item.selectedSize || null,
      //     selectedVariant: item.selectedVariant || null,
      //     selectedAddons: item.selectedAddons || [],
      //     appliedOffer: item.appliedOffer || null,
      //     isFree: false,
      //   };

      //   const qty = item.quantity || item.qty || 1;
      //   for (let i = 0; i < qty; i++) {
      //     dispatch(addItem(cartItem));
      //     loadedCount++;
      //   }
      // });
let loadedCount = 0;
      (order.items || []).forEach((item) => {
        const isFree =
          item.isFree || item.price === 0 || item.itemName?.includes("FREE");
        if (isFree) return;

        const itemId =
          typeof item.itemId === "object" && item.itemId !== null
            ? item.itemId?._id
            : item.itemId || item._id;
        if (!itemId) return;

        // ⭐ Fix: Size ko properly format karein taaki cart merge na kare
        let sizeObj = null;
        if (item.selectedSize) {
          if (typeof item.selectedSize === "object") {
            sizeObj = item.selectedSize;
          } else if (typeof item.selectedSize === "string") {
            sizeObj = { name: item.selectedSize, price: item.price };
          }
        }

        // ⭐ Fix: Variant ko properly format karein
        let variantObj = null;
        if (item.selectedVariant) {
          if (typeof item.selectedVariant === "object") {
            variantObj = item.selectedVariant;
          } else if (typeof item.selectedVariant === "string") {
            variantObj = { name: item.selectedVariant, price: 0 };
          }
        }

        const unitOriginalPrice = Number(
          item.originalPrice !== undefined ? item.originalPrice : (item.price || 0)
        );
        const unitFinalPrice = Number(item.price !== undefined ? item.price : unitOriginalPrice);

        const cartItem = {
          _id: itemId,
          itemId: itemId,
          itemName: item.itemName?.replace(" (FREE)", "") || "Item",
          price: unitFinalPrice,
          originalPrice: unitOriginalPrice,
          discountedPrice: unitFinalPrice,
          basePrice: unitOriginalPrice,
          totalPrice: unitFinalPrice,
          qty: 1,
          quantity: 1,
          isVeg: item.isVeg ?? true,
          image:
            item.image ||
            (typeof item.itemId === "object" ? item.itemId?.image : "") ||
            "",
          selectedSize: sizeObj,
          selectedVariant: variantObj,
          selectedAddons: Array.isArray(item.selectedAddons) ? item.selectedAddons : [],
          appliedOffer: item.appliedOffer || null,
          isFree: false,
        };

        const qty = Number(item.quantity || item.qty || 1);
        for (let i = 0; i < qty; i++) {
          dispatch(addItem(cartItem));
          loadedCount++;
        }
      });
      if (loadedCount === 0) {
        setSnack({
          open: true,
          msg: "No items could be loaded into the cart.",
          type: "warning",
        });
        dispatch(setUpdateOrderId(null));
        return;
      }

      setSnack({
        open: true,
        msg: `${loadedCount} ${loadedCount === 1 ? "item" : "items"} successfully loaded into cart!`,
        type: "success",
      });

      const urlIdentifier = restaurantInfo?.slug || restaurantId;
      setTimeout(() => {
        navigate(`/restaurant/${urlIdentifier}/menu?openCart=true`);
      }, 500);
    } catch (err) {
      console.error("Update click failed:", err);
      setSnack({
        open: true,
        msg: "Cart load failed",
        type: "error",
      });
    }
  };

  // PDF INVOICE DOWNLOAD
  const handleDownloadInvoice = (order) => {
    try {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const orderId = order._id || order.id;
      const shortId = orderId?.toString().slice(-8).toUpperCase();

      const restObj =
        typeof order.restaurant === "object" ? order.restaurant : {};
      const restaurantName =
        restObj.restaurantName ||
        restaurantInfo?.restaurantName ||
        "Restaurant";
      const restaurantAddress =
        restaurantInfo?.restaurantAddress ||
        restaurantInfo?.address ||
        restObj.restaurantAddress ||
        restObj.address ||
        "";
      const restaurantPhone =
        restaurantInfo?.mobile ||
        restaurantInfo?.whatsappNumber ||
        restObj.mobile ||
        restObj.whatsappNumber ||
        "";
      const restaurantCity = restaurantInfo?.city || restObj.city || "";
      const restaurantState = restaurantInfo?.state || restObj.state || "";

      const orderDate = order.createdAt
        ? new Date(order.createdAt).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
        : "N/A";

      const orderTypeLabel =
        {
          DINE_IN: "Dine In",
          DELIVERY: "Delivery",
          TAKEAWAY: "Takeaway",
        }[order.orderType] || order.orderType;

      doc.setFillColor(30, 70, 32);
      doc.rect(0, 0, pageWidth, 36, "F");

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.text(restaurantName.toUpperCase(), 14, 15);

      doc.setFontSize(8.5);
      doc.setFont("helvetica", "normal");
      let restLoc = [restaurantAddress, restaurantCity, restaurantState]
        .filter(Boolean)
        .join(", ");
      if (restLoc) {
        doc.text(doc.splitTextToSize(restLoc, 110), 14, 21);
      }
      if (restaurantPhone) {
        doc.text(`Contact: +91 ${restaurantPhone}`, 14, 30);
      }

      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("TAX INVOICE", pageWidth - 14, 15, { align: "right" });

      doc.setFontSize(8.5);
      doc.setFont("helvetica", "normal");
      doc.text(`Invoice No: #${shortId}`, pageWidth - 14, 22, {
        align: "right",
      });
      doc.text(`Date: ${orderDate}`, pageWidth - 14, 27, { align: "right" });
      doc.text(`Status: ${order.status || "PENDING"}`, pageWidth - 14, 32, {
        align: "right",
      });

      let yPos = 44;

      doc.setFillColor(248, 250, 252);
      doc.setDrawColor(226, 232, 240);
      doc.roundedRect(14, yPos, pageWidth - 28, 28, 2, 2, "FD");

      doc.setTextColor(30, 41, 59);
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("CUSTOMER DETAILS:", 18, yPos + 6);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.text(
        `Name: ${order.customer?.name || "Guest Customer"}`,
        18,
        yPos + 12,
      );
      doc.text(`Phone: ${order.customer?.phone || "N/A"}`, 18, yPos + 17);
      if (order.customer?.address && order.orderType === "DELIVERY") {
        const addressLines = doc.splitTextToSize(
          `Address: ${order.customer.address}`,
          85,
        );
        doc.text(addressLines, 18, yPos + 22);
      }

      const rightColX = pageWidth / 2 + 10;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("ORDER INFORMATION:", rightColX, yPos + 6);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.text(`Order Type: ${orderTypeLabel}`, rightColX, yPos + 12);
      doc.text(
        `Table Number: ${order.tableNumber || "N/A"}`,
        rightColX,
        yPos + 17,
      );
      doc.text(
        `Payment Method: ${order.paymentMethod || "CASH"}`,
        rightColX,
        yPos + 22,
      );

      const tableStartY = yPos + 34;

      const regularItems = (order.items || []).filter((item) => {
        const isFree =
          item.isFree === true ||
          item.price === 0 ||
          item.itemName?.toLowerCase().includes("(free)") ||
          item.appliedOffer?.isFree === true ||
          item.appliedOffer?.offerCategory === "FREE_ITEM";
        return !isFree;
      });

      const itemsBody = regularItems.map((item, idx) => {
        const qty = Number(item.quantity || item.qty || 1);
        const originalPrice = Number(item.originalPrice || item.price || 0);
        const finalPrice = Number(item.price || 0);
        const discountAmount = Math.max(0, originalPrice - finalPrice);
        const total = Number(item.total || finalPrice * qty);

        let itemDesc = item.itemName || "Item";
        const meta = [
          item.selectedSize?.name && `Size: ${item.selectedSize.name}`,
          item.selectedVariant?.name && `Var: ${item.selectedVariant.name}`,
          item.selectedAddons?.length > 0 &&
            `Addons: ${item.selectedAddons.map((a) => a.name).join(", ")}`,
        ]
          .filter(Boolean)
          .join(" | ");

        if (meta) {
          itemDesc += `\n(${meta})`;
        }

        return [
          idx + 1,
          itemDesc,
          qty,
          `Rs. ${originalPrice.toFixed(2)}`,
          discountAmount > 0 ? `-Rs. ${discountAmount.toFixed(2)}` : "—",
          `Rs. ${finalPrice.toFixed(2)}`,
          `Rs. ${total.toFixed(2)}`,
        ];
      });

      const freeItemsMap = new Map();

      (order.freeItems || []).forEach((fi) => {
        const key = fi.itemName.replace(/\(FREE.*?\)/gi, "").trim();
        freeItemsMap.set(key, {
          name: key,
          quantity: fi.quantity || 1,
          price: Number(fi.price || fi.originalPrice || 0),
        });
      });

      (order.items || []).forEach((item) => {
        const isFree =
          item.isFree === true ||
          item.price === 0 ||
          item.itemName?.toLowerCase().includes("(free)") ||
          item.appliedOffer?.isFree === true;

        if (isFree) {
          const key = item.itemName.replace(/\(FREE.*?\)/gi, "").trim();
          if (!freeItemsMap.has(key)) {
            freeItemsMap.set(key, {
              name: key,
              quantity: item.quantity || 1,
              price: Number(item.originalPrice || item.price || 0),
            });
          }
        }
      });

      let currentIndex = regularItems.length;
      freeItemsMap.forEach((fi) => {
        currentIndex++;
        itemsBody.push([
          currentIndex,
          `${fi.name} [FREE OFFER]`,
          fi.quantity,
          `Rs. ${fi.price.toFixed(2)}`,
          "FREE",
          "Rs. 0.00",
          "Rs. 0.00",
        ]);
      });

      autoTable(doc, {
        startY: tableStartY,
        head: [
          [
            "#",
            "Item Description",
            "Qty",
            "Price",
            "Discount",
            "Net Rate",
            "Total",
          ],
        ],
        body: itemsBody,
        theme: "striped",
        headStyles: {
          fillColor: [46, 125, 50],
          textColor: [255, 255, 255],
          fontSize: 8.5,
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          fontSize: 8,
          textColor: [33, 37, 41],
          cellPadding: 2.5,
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 10 },
          1: { cellWidth: "auto" },
          2: { halign: "center", cellWidth: 12 },
          3: { halign: "right", cellWidth: 22 },
          4: { halign: "right", cellWidth: 22, textColor: [46, 125, 50] },
          5: { halign: "right", cellWidth: 22 },
          6: { halign: "right", cellWidth: 25, fontStyle: "bold" },
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250],
        },
        margin: { left: 14, right: 14 },
      });

      let finalY = doc.lastAutoTable.finalY + 6;

      const subtotal = Number(
        order.orderSummary?.subtotal ?? order.subtotal ?? 0,
      );
      const totalDiscount = Number(
        order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0,
      );
      const deliveryCharge = Number(
        order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
      );
      const totalAmount = Number(
        order.orderSummary?.totalAmount ?? order.total ?? 0,
      );
      const paidAmount = Number(
        order.orderSummary?.paidAmount ||
          (order.paymentStatus === "PAID" ? totalAmount : 0) ||
          0,
      );
      const balanceAmount = Number(order.orderSummary?.balanceAmount ?? 0);
      const refundDue = Number(order.orderSummary?.refundDue ?? 0);

      const hasOffers = order.appliedOffers && order.appliedOffers.length > 0;
      if (hasOffers) {
        doc.setFillColor(240, 253, 244);
        doc.setDrawColor(187, 247, 208);
        doc.roundedRect(14, finalY, 85, 28, 2, 2, "FD");

        doc.setFontSize(8.5);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(22, 101, 52);
        doc.text("APPLIED OFFERS / DISCOUNTS:", 18, finalY + 5);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(7.5);
        let offerY = finalY + 10;
        order.appliedOffers.slice(0, 3).forEach((off) => {
          doc.text(
            `• ${off.offerCode}: Save Rs. ${Number(
              off.discountAmount || 0,
            ).toFixed(2)}`,
            18,
            offerY,
          );
          offerY += 4;
        });
      }

      const summaryX = pageWidth - 90;
      let summaryY = finalY + 2;

      doc.setFontSize(8.5);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(71, 85, 105);

      doc.text("Subtotal:", summaryX, summaryY);
      doc.text(`Rs. ${subtotal.toFixed(2)}`, pageWidth - 14, summaryY, {
        align: "right",
      });
      summaryY += 5;

      if (totalDiscount > 0) {
        doc.setTextColor(46, 125, 50);
        doc.text("Total Discounts:", summaryX, summaryY);
        doc.text(`-Rs. ${totalDiscount.toFixed(2)}`, pageWidth - 14, summaryY, {
          align: "right",
        });
        summaryY += 5;
      }

      if (order.orderType === "DELIVERY") {
        doc.setTextColor(71, 85, 105);
        doc.text("Delivery Charge:", summaryX, summaryY);
        doc.text(
          deliveryCharge === 0 ? "FREE" : `Rs. ${deliveryCharge.toFixed(2)}`,
          pageWidth - 14,
          summaryY,
          { align: "right" },
        );
        summaryY += 5;
      }

      doc.setDrawColor(203, 213, 225);
      doc.line(summaryX, summaryY, pageWidth - 14, summaryY);
      summaryY += 5;

      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(15, 23, 42);
      doc.text("Final Total:", summaryX, summaryY);
      doc.setTextColor(46, 125, 50);
      doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
        align: "right",
      });
      summaryY += 6;

      doc.setFontSize(8.5);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(71, 85, 105);
      if (paidAmount > 0) {
        doc.text("Amount Paid:", summaryX, summaryY);
        doc.text(`Rs. ${paidAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
          align: "right",
        });
        summaryY += 5;
      }

      if (balanceAmount > 0) {
        doc.setFont("helvetica", "bold");
        doc.setTextColor(230, 81, 0);
        doc.text("Remaining Balance:", summaryX, summaryY);
        doc.text(`Rs. ${balanceAmount.toFixed(2)}`, pageWidth - 14, summaryY, {
          align: "right",
        });
        summaryY += 5;
      }

      if (refundDue > 0) {
        const boxHeight = 16;
        const boxY = summaryY - 0;

        doc.setFillColor(255, 248, 240);
        doc.setDrawColor(230, 81, 0);
        doc.roundedRect(14, boxY, pageWidth - 28, boxHeight, 2, 2, "FD");

        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(230, 81, 0);
        doc.text("REFUND DUE FROM RESTAURANT", 18, boxY + 6);

        doc.setFontSize(11);
        doc.text(`Rs. ${refundDue.toFixed(2)}`, pageWidth - 18, boxY + 6, {
          align: "right",
        });

        doc.setFontSize(7.5);
        doc.setFont("helvetica", "italic");
        doc.setTextColor(120, 80, 40);
        doc.text(
          "Restaurant will settle this amount via direct UPI or Cash refund",
          18,
          boxY + 12,
        );

        summaryY = boxY + boxHeight + 6;
      }

      const footerY = pageHeight - 16;
      doc.setDrawColor(226, 232, 240);
      doc.line(14, footerY - 4, pageWidth - 14, footerY - 4);

      doc.setFontSize(7.5);
      doc.setFont("helvetica", "italic");
      doc.setTextColor(148, 163, 184);
      doc.text(
        "Thank you for dining with us! Powered by RestaurantWala",
        pageWidth / 2,
        footerY,
        { align: "center" },
      );
      doc.setFontSize(6.5);
      doc.text(
        `Computer generated receipt • Generated on ${new Date().toLocaleString(
          "en-IN",
        )}`,
        pageWidth / 2,
        footerY + 4,
        { align: "center" },
      );

      doc.save(`Invoice_${restaurantName.replace(/\s+/g, "_")}_${shortId}.pdf`);

      setSnack({
        open: true,
        msg: "Invoice downloaded successfully! 📄",
        type: "success",
      });
    } catch (err) {
      console.error("PDF generation failed:", err);
      setSnack({
        open: true,
        msg: "Failed to download invoice",
        type: "error",
      });
    }
  };

  if (loading && filteredOrders.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <CircularProgress sx={{ color: "var(--primary, #FF6B00)" }} />
      </Box>
    );
  }

  const isEmpty = filteredOrders.length === 0;

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 6 }}>
      <Box sx={{ px: { xs: 1.5, sm: 2 }, pt: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Button
            size="small"
            variant="text"
            onClick={() =>
              getMyOrders({ page: 1, limit: PAGE_SIZE, append: false })
            }
            startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
            sx={{
              textTransform: "none",
              color: "var(--primary, #FF6B00)",
              fontWeight: 700,
              fontSize: "0.75rem",
            }}
          >
            Refresh
          </Button>
        </Box>

        {/* Empty state */}
        {isEmpty && !loading && (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                bgcolor: "#fff3e0",
                mx: "auto",
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ReceiptLongIcon
                sx={{ fontSize: 36, color: "var(--primary, #FF6B00)" }}
              />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, color: "#333", mb: 0.5 }}
            >
              No orders yet
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#888", display: "block", mb: 2 }}
            >
              Place your first order from the menu!
            </Typography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                const targetId = restaurantInfo?.slug || restaurantId;
                navigate(`/restaurant/${targetId}/menu`);
              }}
              sx={{
                borderColor: "var(--primary, #FF6B00)",
                color: "var(--primary, #FF6B00)",
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Browse Menu
            </Button>
          </Box>
        )}

        {/* Orders list */}
        {filteredOrders.map((order, index) => {
          const isPending = order.status === "PENDING";
          const orderId = order._id || order.id;
          const shortId = orderId?.toString().slice(-8).toUpperCase();
          const freeItemsValue =
            order.freeItems?.reduce(
              (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
              0,
            ) || 0;
          const subtotal = order.orderSummary?.subtotal ?? order.subtotal ?? 0;
          const totalDiscount =
            order.orderSummary?.totalDiscount ?? order.totalDiscount ?? 0;
          const deliveryCharge = Number(
            order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
          );
          const total = Number(order.orderSummary?.totalAmount ?? order.total ?? 0);

          const paidAmount = Number(
            order.orderSummary?.paidAmount ||
              (order.paymentStatus === "PAID" ? total : 0) ||
              0,
          );
          const balanceAmount = Number(
            order.orderSummary?.balanceAmount ??
              (total > paidAmount ? total - paidAmount : 0),
          );
          const refundDue = Number(
            order.orderSummary?.refundDue ??
              (paidAmount > total && total > 0 ? paidAmount - total : 0),
          );

          return (
            <Paper
              key={orderId || index}
              elevation={0}
              sx={{
                borderRadius: 3,
                bgcolor: "white",
                border: "1px solid #f0f0f0",
                mb: 1.5,
                overflow: "hidden",
                boxShadow:
                  index === 0
                    ? "0 2px 12px rgba(255,107,0,0.12)"
                    : "0 1px 4px rgba(0,0,0,0.06)",
              }}
            >
              {index === 0 && (
                <Box
                  sx={{
                    bgcolor: "rgba(255,107,0,0.08)",
                    px: 2,
                    py: 0.6,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                  }}
                >
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      bgcolor: "var(--primary, #FF6B00)",
                      animation: "pulse 1.5s infinite",
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "var(--primary, #FF6B00)",
                      fontWeight: 700,
                      fontSize: "0.72rem",
                    }}
                  >
                    Latest Order
                  </Typography>
                </Box>
              )}

              <Box sx={{ p: 2 }}>
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 1.2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.85rem",
                        color: "#1a1a1a",
                      }}
                    >
                      Order #{shortId}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mt: 0.3,
                      }}
                    >
                      <AccessTimeIcon sx={{ fontSize: 12, color: "#aaa" }} />
                      <Typography
                        variant="caption"
                        sx={{ color: "#aaa", fontSize: "0.7rem" }}
                      >
                        {order.createdAt
                          ? new Date(order.createdAt).toLocaleString("en-IN", {
                              day: "numeric",
                              month: "short",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "Recently"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: 0.5,
                    }}
                  >
                    <OrderTypeLabel type={order.orderType} />
                    <StatusChip status={order.status} />
                  </Box>
                </Box>

                <Divider sx={{ mb: 1.2 }} />

                <OrderItems
                  items={order.items}
                  freeItems={order.freeItems}
                  freeItemsValue={freeItemsValue}
                />

                {/* Summary */}
                <Box sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #f0f0f0" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#333",
                      mb: 1,
                      display: "block",
                      fontSize: "0.75rem",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Order Summary
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 0.5,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ color: "#666", fontSize: "0.78rem" }}
                    >
                      Subtotal
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, fontSize: "0.78rem" }}
                    >
                      ₹{Number(subtotal).toFixed(2)}
                    </Typography>
                  </Box>

                  {totalDiscount > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ color: "#2e7d32", fontSize: "0.78rem" }}
                      >
                        Total discounts
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#2e7d32",
                          fontWeight: 700,
                          fontSize: "0.78rem",
                        }}
                      >
                        -₹{Number(totalDiscount).toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {order.orderType === "DELIVERY" && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ color: "#666", fontSize: "0.78rem" }}
                      >
                        Delivery Charge
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.78rem",
                          color: deliveryCharge === 0 ? "#2e7d32" : "#1a1a1a",
                        }}
                      >
                        {deliveryCharge === 0
                          ? "FREE"
                          : `₹${deliveryCharge.toFixed(2)}`}
                      </Typography>
                    </Box>
                  )}

                  <Divider sx={{ my: 0.8 }} />

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 700, fontSize: "0.85rem" }}
                    >
                      Total Amount
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 800,
                        color: "#2e7d32",
                        fontSize: "0.9rem",
                      }}
                    >
                      ₹{Number(total).toFixed(2)}
                    </Typography>
                  </Box>

                  {/* Already Paid Earlier */}
                  {paidAmount > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0.5,
                        px: 1,
                        py: 0.4,
                        bgcolor: "#f0fdf4",
                        borderRadius: 1.5,
                        border: "1px dashed #86efac",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ color: "#166534", fontWeight: 700, fontSize: "0.75rem" }}
                      >
                        ✓ Already Paid Earlier:
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ fontWeight: 800, color: "#166534", fontSize: "0.8rem" }}
                      >
                        ₹{paidAmount.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* Remaining to Pay */}
                  {balanceAmount > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0.5,
                        px: 1,
                        py: 0.4,
                        bgcolor: "#fff7ed",
                        borderRadius: 1.5,
                        border: "1px dashed #fdba74",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ color: "#c2410c", fontWeight: 800, fontSize: "0.78rem" }}
                      >
                        Remaining to Pay:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 900, color: "#c2410c", fontSize: "0.85rem" }}
                      >
                        ₹{balanceAmount.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* Refund Due Section */}
                  {refundDue > 0 && (
                    <Box
                      sx={{
                        mt: 1.2,
                        p: 1.2,
                        bgcolor: "#fff3e0",
                        borderRadius: 2,
                        border: "1px dashed #e65100",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 800,
                            color: "#e65100",
                            display: "block",
                          }}
                        >
                          ⏳ Refund Due from Restaurant:
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "0.68rem" }}
                        >
                          Items were reduced. The restaurant will settle ₹
                          {refundDue.toFixed(2)} via direct UPI or Cash.
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 900, color: "#e65100" }}
                      >
                        ₹{refundDue.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* ⭐ RESTAURANT PAYMENT DETAILS (UPI ID & PHONEPE) WITH COPY BUTTON */}
                  {/* {(paymentSettings.upiId || paymentSettings.phonePeNumber) && (
                    <Box
                      sx={{
                        mt: 1.2,
                        p: 1.2,
                        bgcolor: "#f8fafc",
                        borderRadius: 2,
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 700,
                          color: "#334155",
                          display: "block",
                          mb: 0.8,
                          fontSize: "0.72rem",
                          textTransform: "uppercase",
                        }}
                      >
                        Restaurant Payment Details
                      </Typography>

                
                      {paymentSettings.upiId && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: paymentSettings.phonePeNumber ? 0.6 : 0,
                            p: 0.6,
                            bgcolor: "#fff",
                            borderRadius: 1,
                            border: "1px solid #f1f5f9",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700, color: "#1976d2", fontSize: "0.72rem" }}
                            >
                              UPI ID:
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 600,
                                color: "#1e293b",
                                fontSize: "0.75rem",
                                wordBreak: "break-all",
                              }}
                            >
                              {paymentSettings.upiId}
                            </Typography>
                          </Box>
                          <Tooltip title={copiedKey === `upi-${orderId}` ? "Copied!" : "Copy UPI ID"}>
                            <IconButton
                              size="small"
                              onClick={() => handleCopy(paymentSettings.upiId, `upi-${orderId}`)}
                              sx={{ p: 0.4 }}
                            >
                              {copiedKey === `upi-${orderId}` ? (
                                <CheckIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                              ) : (
                                <ContentCopyIcon sx={{ fontSize: 14, color: "#64748b" }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}

                      {paymentSettings.phonePeNumber && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 0.6,
                            bgcolor: "#fff",
                            borderRadius: 1,
                            border: "1px solid #f1f5f9",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700, color: "#673ab7", fontSize: "0.72rem" }}
                            >
                              PhonePe:
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 600,
                                color: "#1e293b",
                                fontSize: "0.75rem",
                              }}
                            >
                              {paymentSettings.phonePeNumber}
                            </Typography>
                          </Box>
                          <Tooltip title={copiedKey === `phonepe-${orderId}` ? "Copied!" : "Copy Number"}>
                            <IconButton
                              size="small"
                              onClick={() => handleCopy(paymentSettings.phonePeNumber, `phonepe-${orderId}`)}
                              sx={{ p: 0.4 }}
                            >
                              {copiedKey === `phonepe-${orderId}` ? (
                                <CheckIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                              ) : (
                                <ContentCopyIcon sx={{ fontSize: 14, color: "#64748b" }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </Box>
                  )} */}

                  {order.paymentStatus === "REFUNDED" && (
                    <Box
                      sx={{
                        mt: 1.2,
                        p: 1,
                        bgcolor: "#e8f5e9",
                        borderRadius: 2,
                        border: "1px solid #a5d6a7",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ fontWeight: 700, color: "#2e7d32" }}
                      >
                        {/* Refund Completed: Restaurant has settled your refund amount. */}
                        Refund Completed: Restaurant has settled your refund amount of ₹{paidAmount.toFixed(2)}.
                      </Typography>
                    </Box>
                  )}

                  {totalDiscount > 0 && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "right",
                        color: "#2e7d32",
                        mt: 0.5,
                        fontSize: "0.7rem",
                        fontWeight: 600,
                      }}
                    >
                      🎉 You saved ₹{Number(totalDiscount).toFixed(2)}!
                    </Typography>
                  )}
                </Box>

                {/* Actions */}
                <Box
                  sx={{ display: "flex", gap: 1, mt: 1.5, flexWrap: "wrap" }}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<WhatsAppIcon sx={{ fontSize: 16 }} />}
                    onClick={() => {
                      const restaurantPhone =
                        typeof order.restaurant === "object"
                          ? order.restaurant?.whatsappNumber
                          : restaurantInfo?.whatsappNumber;
                      const fallbackPhone = "917734904014";
                      const phone = restaurantPhone || fallbackPhone;
                      const message = `Hi, I'd like to follow up on my order #${shortId}`;
                      window.open(
                        `https://wa.me/${phone}?text=${encodeURIComponent(
                          message,
                        )}`,
                        "_blank",
                      );
                    }}
                    sx={{
                      borderColor: "#25D366",
                      color: "#25D366",
                      "&:hover": {
                        bgcolor: "#f0fff4",
                        borderColor: "#128C7E",
                      },
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                      flex: 1,
                      minWidth: 100,
                    }}
                  >
                    WhatsApp
                  </Button>

                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
                    onClick={() => handleDownloadInvoice(order)}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                      flex: 1,
                      minWidth: 100,
                      borderColor: "#2e7d32",
                      color: "#2e7d32",
                      "&:hover": {
                        bgcolor: "#e8f5e9",
                        borderColor: "#1b5e20",
                      },
                    }}
                  >
                    Invoice
                  </Button>

                  {isPending && (
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      startIcon={<EditIcon sx={{ fontSize: 16 }} />}
                      onClick={() => handleUpdateClick(order)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.78rem",
                        flex: 1,
                        minWidth: 100,
                      }}
                    >
                      Update
                    </Button>
                  )}

                  {isPending && (
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      startIcon={<CancelIcon sx={{ fontSize: 16 }} />}
                      onClick={() => handleCancelClick(order)}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.78rem",
                        flex: 1,
                        minWidth: 100,
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                </Box>
              </Box>
            </Paper>
          );
        })}

        {/* Infinite scroll sentinel */}
        {!isEmpty && (
          <Box
            ref={loadMoreRef}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 3,
              minHeight: 60,
            }}
          >
            {loadingMore && (
              <CircularProgress
                size={28}
                sx={{ color: "var(--primary, #FF6B00)" }}
              />
            )}
            {!hasMore && filteredOrders.length > 0 && (
              <Typography
                variant="caption"
                sx={{
                  color: "#aaa",
                  fontSize: "0.72rem",
                  fontWeight: 600,
                  letterSpacing: 0.4,
                }}
              >
                {/* — End of orders — */}
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {/* Cancel Dialog */}
      <Dialog
        open={cancelDialog.open}
        onClose={() => setCancelDialog({ open: false, order: null })}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#c62828" }}>
          Cancel Order?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Are you sure you want to cancel order #
            {(cancelDialog.order?._id || cancelDialog.order?.id)
              ?.toString()
              .slice(-8)
              .toUpperCase()}
            ?
          </Typography>
          <TextField
            fullWidth
            size="small"
            label="Reason (optional)"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            multiline
            rows={2}
            placeholder="e.g. Changed my mind"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setCancelDialog({ open: false, order: null })}>
            No, Keep it
          </Button>
          <Button
            onClick={handleCancelConfirm}
            color="error"
            variant="contained"
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ bottom: 70 }}
      >
        <Alert severity={snack.type} variant="filled" sx={{ borderRadius: 2 }}>
          {snack.msg}
        </Alert>
      </Snackbar>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(1.2); }
          }
        `}
      </style>
    </Box>
  );
};

export default OrdersPage;